<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
    >
      <LeftMenu />

      <div
        class="m-grid__item m-grid__item--fluid m-wrapper"
        v-if="canSeeListPropertySection"
      >
        <div class="m-content">
          <!-- begin::LIST -->
          <div class="row" id="propertyList">
            <div class="col-xl-12">
              <!--Begin::Portlet-->
              <div
                :m-portlet="'true'"
                class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i
                          class="flaticon-signs-1 m--font-brand m--icon-font-size-lg1 mt-n1"
                        ></i>
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ heading }}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a
                          href="javascript:"
                          :m-portlet-tool="'fullscreen'"
                          data-trigger="hover"
                          class="m-portlet__nav-link m-portlet__nav-link--icon"
                          ><i class="la la-expand"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body">
                  <!--Begin::Draft Properties-->
                  <div class="row" v-if="drafts.length > 0">
                    <div class="col-xl-12">
                      <a
                        href="javascript:"
                        id="Drafts"
                        class="font-weight-bold text-danger"
                        data-toggle="collapse"
                        data-target="#personalItemList"
                        aria-expanded="false"
                        aria-controls="personalItemList"
                      >
                        <div
                          class="m-alert m-alert--icon m-alert--icon-solid m-alert--outlinef alert alert-danger fade show"
                          role="alert"
                        >
                          <div class="m-alert__icon">
                            <i class="flaticon-danger"></i>
                            <span></span>
                          </div>
                          <div class="m-alert__text">
                            <strong>{{ this.$t("PersonalItems.Attention") }}:</strong>
                            <template v-if="drafts.length == 1">{{ this.$t("PersonalItems.messageHaveItem") }}</template>
                            <template v-if="drafts.length > 1">{{ this.$t("PersonalItems.messageHaveItems", { total: drafts.length }) }}</template>
                          </div>
                          <div class="m-alert__toggle">
                            <i class="la la-angle-up"></i>
                          </div>
                        </div>
                      </a>
                      <div class="collapse mb-2" id="personalItemList">
                        <div class="card card-body border-danger">
                          <div class="table-responsive">
                            <table
                              id="personalItemTable"
                              class="table m-table m-table--head-no-border table table-striped mb-0"
                            >
                              <thead>
                                <tr>
                                  <th style="width: 160px" class="text-left">
                                    {{ $t("Property.table.image") }}
                                  </th>
                                  <th style="width: 150px" class="text-left">
                                    {{ $t("Property.table.reference") }}
                                  </th>
                                  <th style="width: 200px" class="text-left">
                                    {{ $t("Property.table.type") }}
                                  </th>
                                  <th style="width: 250px" class="text-left">
                                    {{ $t("Property.table.salerent") }}
                                  </th>
                                  <th style="width: auto" class="text-left">
                                    {{ $t("Property.table.location") }}
                                  </th>
                                  <th style="width: 150px" class="text-left">
                                    {{ $t("Property.table.price") }}
                                  </th>
                                  <th style="width: 120px" class="text-left">
                                    {{ $t("Property.table.actions") }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(draft, index) in drafts" class="m-table__row" :key="index">
                                  <td
                                    class="align-middle position-relative thumbnailTableContainer align-middle"
                                    data-thead-name=""
                                  >
                                    <template
                                      v-if="draft.Content.Photos && draft.Content.Photos[0]"
                                    >
                                      <div class="thumbnailTable">
                                        <div class="ratio-4-3">
                                          <img :src="draft.Content.Photos[0].Url" />
                                        </div>
                                      </div>
                                    </template>
                                    <span v-else class="">
                                      <span class="img-cont no-logo">
                                        <i
                                          class="la la-camera la-ban m--icon-font-size-lg3 d-block"
                                        ></i>
                                      </span>
                                      <span class="d-block small">{{
                                        $t("common.NoImages")
                                      }}</span>
                                    </span>
                                  </td>
                                  <td
                                    class="align-middle"
                                    :data-thead-name="$t('Property.table.reference')"
                                  >
                                    {{ draft.Content.AgentRef }}
                                  </td>
                                  <td
                                    class="align-middle"
                                    :data-thead-name="$t('Property.table.type')"
                                  >
                                    {{
                                      draft.Content.Type && draft.Content.Type.Labels ? draft.Content.Type.Labels[userLang] : ''
                                    }}
                                  </td>
                                  <td
                                    class="align-middle"
                                    :data-thead-name="
                                      $t('Property.table.offertype')
                                    "
                                  >
                                    {{
                                      draft.Content.OfferType && draft.Content.OfferType.Labels ? draft.Content.OfferType.Labels[userLang] : ''
                                    }}
                                  </td>
                                  <td
                                    class="align-middle"
                                    :data-thead-name="
                                      $t('Property.table.location')
                                    "
                                  >
                                    <template v-if="draft.Content.Location">{{ draft.Content.Location.text[userLang] }}</template>
                                  </td>

                                  <td
                                    class="align-middle text-left"
                                    :data-thead-name="
                                      $t('Property.table.price')
                                    "
                                    v-html="showPrice(draft.Content)"
                                  >
                                  </td>
                                  <td
                                    class="align-middle text-center text-xs-left text-sm-left text-md-left text-lg-center position-relative actionBtnTd"
                                  >
                                    <a
                                      href="javascript:"
                                      :id="'actionBtn' + draft.Id"
                                      class="m-portlet__nav-link m-dropdown__toggle btn m-btn m-btn--link"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="true"
                                    >
                                      <i class="la la-ellipsis-h"></i>
                                    </a>
                                    <div
                                      class="dropdown-menu m-dropdown__wrapper"
                                      :aria-labelledby="
                                        'actionBtn' + draft.Id
                                      "
                                    >
                                      <div class="px-1">
                                        <ul class="m-nav">
                                          <li class="m-nav__item">
                                            <a
                                              href="javascript:"
                                              class="btn btn-brand m-btn btn-block m-btn--wide btn-sm"
                                              @click.prevent="
                                                editPersonalItem(draft)
                                              "
                                            >
                                              {{ $t("common.Edit") }}
                                            </a>
                                          </li>
                                          <li class="m-nav__item mt-1">
                                            <a
                                              href="javascript:"
                                              class="btn m--font-white btn-danger m-btn btn-block m-btn--wide btn-sm"
                                              @click.prevent="deletePersonalItem(draft.Id)"
                                            >
                                              {{ $t("common.Delete") }}
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--End::Draft Properties-->

                  <div class="row">
                    <div
                      class="col-12 col-md-12 col-sm-12 col-lg-12 form-group"
                    >
                      <a
                        class="btn-sm font-weight-light m--font-light btn btn-metal m-btn m-btn--custom m-btn--icon btn-sm-block collapsed myb-sm-2"
                        id="filtersBtn"
                        data-toggle="collapse"
                        data-keyboard="false"
                        href="#PropertySearchFrm"
                        aria-controls="PropertySearchFrm"
                      >
                        <i
                          class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2"
                        ></i>
                        <span class="d-inline" id="moreFiltersSpan">{{
                          $t("Property.Analytics.Morefilters")
                        }}</span>
                      </a>
                      <a
                        class="btn-sm font-weight-light m--font-light btn btn-brand m-btn m-btn--custom m-btn--icon btn-sm-block pull-right"
                        data-toggle="modal"
                        data-keyboard="false"
                        data-backdrop="static"
                        @click="addProperty()"
                      >
                        <span>
                          <i class="la la-plus"></i>
                          {{ $t("Property.btns.addProperty") }}
                        </span>
                      </a>
                    </div>
                  </div>

                  <!--Begin::Search Properties -->
                  <div style="" class="m-form collapse" id="PropertySearchFrm">
                    <div class="m-separator m-separator--dashed mt-2"></div>
                    <div class="row">
                      <div class="col-xl-12">
                        <form
                          action=""
                          class="m-form"
                          @submit.prevent="freshSearch"
                        >
                          <div class="row">
                            <div class="col">
                              <div class="row">
                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg col-xxl form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.Status")
                                        }}:</label
                                      >
                                    </div>
                                    <v-select
                                      :options="statuses"
                                      :reduce="(option) => option.value"
                                      :clearable="false"
                                      id="Status"
                                      name="Status"
                                      :searchable="false"
                                      label="label"
                                      v-model="params.Status"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid"
                                    >
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg col-xxl form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.featured")
                                        }}:</label
                                      >
                                    </div>
                                    <v-select
                                      :options="featured"
                                      :clearable="false"
                                      :searchable="false"
                                      label="label"
                                      v-model="params.Featured"
                                      :placeholder="$t('common.select')"
                                      :reduce="(option) => option.value"
                                      class="custom-select form-control m-input--solid"
                                    >
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-sm-12 col-md-6 col-lg col-xl form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{ $t("Property.form.Id") }}:</label
                                      >
                                    </div>

                                    <input
                                      v-model.number="params.Id"
                                      type="number"
                                      step="1"
                                      name="Id"
                                      class="form-control m-input m-input--solid"
                                      :placeholder="$t('common.Eg') + '123456'"
                                    />
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>
                                <div
                                  class="col-12 col-sm-12 col-md-6 col-lg col-xl form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.yourreference")
                                        }}:</label
                                      >
                                    </div>
                                    <input
                                      v-model="params.AgentRef"
                                      type="text"
                                      name="Ref"
                                      class="form-control m-input m-input--solid"
                                      :placeholder="
                                        $t('common.Eg') + '1234567AX8912'
                                      "
                                    />
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="w-100 d-sm-none d-md-none d-lg-block"
                                ></div>
                                <div
                                  class="col-12 col-sm-12 col-md-6 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.Location")
                                        }}:</label
                                      >
                                    </div>
                                    <div class="input-group">
                                      <v-select
                                        @search="suggestLocations"
                                        :filterable="false"
                                        :options="suggestedLocations"
                                        v-model="params.Location"
                                        :placeholder="$t('common.Eg') + 'Denia, Alicante'"
                                        class="custom-select form-control m-input--solid noclose"
                                        label="name"
                                      >
                                        <template slot="selected-option" slot-scope="option">
                                          {{ option.text[userLang] }}
                                        </template>
                                        <template slot="no-options">
                                          <span v-if="suggestedLocationsText.length > 2">
                                            {{ $t('common.NoMatchingLocations') }}
                                          </span>
                                          <span v-else>
                                          </span>
                                        </template>
                                        <template slot="option" slot-scope="option">
                                          <p style="line-height: 22px;margin: 0px;padding:6px 0px 4px 6px;" v-html="formatSuggestedLocation( option, suggestedLocationsText )">
                                          </p>
                                        </template>
                                      </v-select>
                                    </div>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  v-if="params.Location && validPropertyLocationTypes.includes(params.Location.type)"
                                  class="col-12 col-sm-12 col-md-6 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.Radius")
                                        }}:</label
                                      >
                                    </div>
                                    <v-select
                                      :options="radiuses"
                                      v-model="params.Radius"
                                      :placeholder="
                                        $t('common.Select/CustomValue')
                                      "
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <template
                                        slot="option"
                                        slot-scope="option"
                                      >
                                        {{ option.label }} Kms
                                      </template>
                                      <template
                                        slot="selected-option"
                                        slot-scope="option"
                                      >
                                        {{ option.label }} Kms
                                      </template>
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-sm-12 col-md-6 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{ $t("Property.form.type") }}:</label
                                      >
                                    </div>
                                    <v-select
                                      id="params.Types"
                                      :options="propertyTypes"
                                      multiple
                                      v-model="params.Types"
                                      :get-option-label="(option) => option.Labels[userLang]"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid"
                                    >
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="w-100 d-sm-none d-md-none d-lg-block"
                                ></div>
                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.minPrice")
                                        }}:</label
                                      >
                                    </div>

                                    <input
                                      v-model.number="params.MinPrice"
                                      type="number"
                                      step="0.01"
                                      inputmode="decimal"
                                      :label="userLang"
                                      name="MinPrice"
                                      class="form-control m-input m-input--solid"
                                      :placeholder="
                                        $t('Property.form.minPrice')
                                      "
                                    />
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.maxPrice")
                                        }}:</label
                                      >
                                    </div>

                                    <input
                                      v-model.number="params.MaxPrice"
                                      type="number"
                                      step="0.01"
                                      inputmode="decimal"
                                      name="MaxPrice"
                                      class="form-control m-input m-input--solid"
                                      :placeholder="
                                        $t('Property.form.maxPrice')
                                      "
                                    />
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.bedrooms")
                                        }}:</label
                                      >
                                    </div>

                                    <v-select
                                      :options="bedrooms"
                                      name="MinBedrooms"
                                      :searchable="false"
                                      :clearable="true"
                                      v-model.number="params.MinBedrooms"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid"
                                    >
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.bathrooms")
                                        }}:</label
                                      >
                                    </div>

                                    <v-select
                                      :options="bathrooms"
                                      name="MinBathrooms"
                                      :searchable="false"
                                      :clearable="true"
                                      v-model.number="params.MinBathrooms"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid"
                                    >
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="w-100 d-sm-none d-md-none d-lg-block"
                                ></div>

                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg-4 form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.MustHave")
                                        }}:</label
                                      >
                                    </div>

                                    <v-select
                                      :options="features"
                                      id="Features"
                                      name="Features"
                                      :multiple="true"
                                      :clearable="true"
                                      v-model="params.Features"
                                      :placeholder="$t('common.select')"
                                      :get-option-label="
                                        (option) => option.Labels[userLang]
                                      "
                                      class="features-select custom-select form-control m-input--solid"
                                    >
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{ $t("Property.form.Build") }}:</label
                                      >
                                    </div>

                                    <v-select
                                      :options="builds"
                                      type="number"
                                      step="1"
                                      label="label"
                                      :taggable="false"
                                      name="MinBuild"
                                      v-model.number="params.MinBuild"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <template
                                        slot="option"
                                        slot-scope="option"
                                      >
                                        {{ option.label }}m<sup>2</sup>
                                      </template>
                                      <template
                                        slot="selected-option"
                                        slot-scope="option"
                                      >
                                        {{ option.label }}m<sup>2</sup>
                                      </template>
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-md-6 col-sm-12 col-lg form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{ $t("Property.form.Plot") }}:</label
                                      >
                                    </div>

                                    <v-select
                                      :options="builds"
                                      :clearable="true"
                                      :taggable="false"
                                      name="MinPlot"
                                      v-model.number="params.MinPlot"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <template
                                        slot="option"
                                        slot-scope="option"
                                      >
                                        {{ option.label }}m<sup>2</sup>
                                      </template>
                                      <template
                                        slot="selected-option"
                                        slot-scope="option"
                                      >
                                        {{ option.label }}m<sup>2</sup>
                                      </template>
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>

                                <div
                                  class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl form-group"
                                >
                                  <div class="form_group">
                                    <div class="m-form_label">
                                      <label
                                        >{{
                                          $t("Property.form.offertype")
                                        }}:</label
                                      >
                                    </div>
                                    <v-select
                                      :options="offerTypes"
                                      :searchable="false"
                                      :get-option-label="option => option.Labels[userLang]"
                                      :reduce="(option) => option.Id"
                                      :clearable="true"
                                      v-model="params.OfferType"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid"
                                    >
                                    </v-select>
                                  </div>
                                  <div
                                    class="d-lg-none m--margin-bottom-10"
                                  ></div>
                                </div>
                              </div>
                              <div class="row mt-3 mb-2">
                                <div class="col">
                                  <button
                                    type="submit"
                                    class="btn-sm btn btn-brand btn-sm font-weight-light m--font-light btn m-btn m-btn--custom m-btn--icon btn-xs-block"
                                  >
                                    <span>
                                      <i class="la la-search"></i>
                                      <span>{{
                                        $t("common.ApplyFilters")
                                      }}</span>
                                    </span>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn-sm btn btn-danger btn-sm font-weight-light m--font-light btn m-btn m-btn--custom m-btn--icon btn-xs-block"
                                  >
                                    <span>
                                      <i class="la la-search-minus"></i>
                                      <span @click="clearForm()">{{
                                        $t("Property.form.Clear")
                                      }}</span>
                                    </span>
                                  </button>
                                  <a
                                    class="btn-sm font-weight-light m--font-light btn btn-metal m-btn m-btn--custom m-btn--icon btn-xs-block"
                                    data-toggle="collapse"
                                    data-keyboard="false"
                                    href="#PropertySearchFrm"
                                    aria-controls="PropertySearchFrm"
                                  >
                                    <i
                                      class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2"
                                    ></i>
                                    <span class="d-inline">{{
                                      $t("Property.Analytics.Hidefilters")
                                    }}</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="m-separator m-separator--dashed mt-2"></div>
                  <div class="row mb-1">
                    <div class="col-xl-7 col-md-12 col-sm-12 col-12 pull-left">
                      <div class="form-group m-form__group">
                        <div class="mt-2">
                          <label class="mr-1"
                            >{{ $t("Property.table.Records") }}:</label
                          >

                          <span v-if="loading" class="small">
                            ({{ $t("Property.table.Loadingdata") }})
                          </span>
                          <span
                            v-else-if="properties.length == 0"
                            :class="{ vhidden: loading }"
                            >{{ $t("Property.table.NoRecordsFound") }}</span
                          >
                          <span v-else-if="totalFrom !== totalTo"
                            >{{ totalFrom }} {{ $t("Property.table.To") }}
                            {{ totalTo }} {{ $t("Property.table.From") }}
                            {{ totalResults }}</span
                          >
                          <span v-else-if="totalFrom === totalTo"
                            >{{ totalFrom }} {{ $t("Property.table.To") }}
                            {{ totalTo }}</span
                          >
                          <span class="legend">
                            <span class="legend--item">
                              <span :class="'color color--active'">
                                <span></span>
                              </span>
                              {{ $t("property.Legend.active") }}
                            </span>
                            <span class="legend--item">
                              <span :class="'color color--offline'"></span>
                              {{ $t("property.Legend.deactivated") }}
                            </span>

                            <span class="legend--item">
                              <span :class="'color color--suspended'"></span>
                              {{ $t("property.Legend.suspended") }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-md-12 col-sm-12 col-12 pull-right">
                      <div class="form-group m-form__group row order-by">
                        <div class="col-12">
                          <label class="d-inline-block mr-1 pt-2"
                            >{{ $t("Property.table.OrderBy") }}:</label
                          >

                          <div class="d-inline-block mr-1">
                            <select
                              id="orderType"
                              class="custom-select custom-select-sm form-control m-input--solid"
                              @change="runSearch"
                              v-model="params.Order"
                            >
                              <option
                                v-for="(order, index) in orders"
                                :key="index"
                                :value="order.value"
                              >
                                {{ order.label }}
                              </option>
                            </select>
                          </div>
                          <div class="d-inline-block">
                            <select
                              id="orderDirection"
                              class="custom-select custom-select-sm form-control m-input--solid"
                              @change="runSearch"
                              v-model="params.OrderDirection"
                            >
                              <option
                                v-for="(
                                  orderDirection, index
                                ) in orderDirections"
                                :key="index"
                                :value="orderDirection.value"
                              >
                                {{ orderDirection.label }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-1" v-if="anyAutoFeatured">
                    <div class="col-xl-7 col-md-12 col-sm-12 col-12 pull-left">
                      <div class="form-group m-form__group">
                        <div class="mt-2">
                          <span>{{ $t('property.autoFeaturedNote') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--End::Search Properties -->

                  <!--Begin: List Properties -->
                  <div v-if="properties" class="table_sticky-header">
                    <table
                      id="tableProperties"
                      v-if="properties"
                      class="table m-table m-table--head-no-border table table-striped"
                    >
                      <thead>
                        <tr>
                          <th style="width: 30px" class="text-left">
                            <i class="flaticon-eye d-block"></i>
                          </th>
                          <th style="width: 100px" class="text-left"></th>
                          <th style="width: 250px" class="text-left">
                            {{ $t("Property.table.Id") }}
                            <span
                              data-ts-ordername="Property/Id"
                              class="orderby"
                            ></span>
                            <small> / </small>
                            {{ $t("Property.table.reference") }}
                            <span
                              data-ts-ordername="Property/AgentRef"
                              class="orderby"
                            ></span>
                            <small> / </small>{{ $t("Property.table.price") }}
                            <span
                              data-ts-ordername="Property/NormalizedPriceInEuro"
                              class="orderby"
                            ></span>
                          </th>
                          <th style="width: 250px" class="text-left">
                            {{ $t("Property.table.type") }}<small> / </small
                            >{{ $t("Property.table.offertype") }}
                          </th>
                          <th style="width: auto" class="text-left">
                            {{ $t("Property.table.location") }}
                            <span
                              data-ts-ordername="Town/Name"
                              class="orderby"
                            ></span>
                            <span
                              data-ts-ordername="Province/Name"
                              class="orderby"
                            ></span>
                          </th>
                          <th style="width: 180px" class="text-left">
                            {{ $t("Property.table.featured") }}
                          </th>
                          <th style="width: 100px" class="text-left">
                            {{ $t("Property.table.actions") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(property, index) in properties"
                          :class="{
                            'm-table__row': true,
                            suspended: property.Suspended,
                            offline: property.Status == 'deactivated',
                          }"
                          :key="index"
                        >
                          <td class="align-middle text-center">
                            <template>
                              <a
                                class="d-block-md d-block-lg d-inline-block d-sm-inline-block text-center"
                                style="line-height: 1em"
                                :href="
                                  ts_url +
                                  '/' +
                                  userLang +
                                  '/redirect-to-property/' +
                                  property.Id +
                                  '?preview=1'
                                "
                                target="_blank"
                              >
                                <i class="la la-camera"></i>
                              </a>
                            </template>
                            <template>
                              <a
                                v-for="(media, index) in property.Medias"
                                :key="index"
                                :href="
                                  ts_url +
                                  '/' +
                                  userLang +
                                  '/redirect-to-property/' +
                                  property.Id +
                                  '?preview=1&media=' +
                                  media.type
                                "
                                class="myb-md-2 mxl-md-2 d-block-md d-block-lg d-inline-block d-sm-inline-block text-center"
                                style="line-height: 1em"
                                target="_blank"
                              >
                                <template v-if="media.type == 'video'"
                                  ><i class="la la-youtube-play"></i
                                ></template>
                                <template v-if="media.type == 'floorplan'"
                                  ><i class="la la-map"></i
                                ></template>
                                <template v-if="media.type == 'virtualtour'"
                                  ><i class="la la-street-view"></i
                                ></template>
                              </a>
                            </template>
                          </td>
                          <td
                            class="align-middle position-relative thumbnailTableContainer align-middle"
                            data-thead-name=""
                          >
                            <template v-if="getFirstPhoto(property)">
                              <div class="thumbnailTable">
                                <div class="ratio-4-3">
                                  <img :data-orgurl="getFirstPhoto(property).Url" :src="formatCdnPath(getFirstPhoto(property).CdnUrl)"
                                    @error="setAltImageFromOrgUrl"
                                  >
                                </div>
                              </div>
                            </template>

                            <div
                              v-if="(property.Photos || []).length > 0"
                              class="m-badge m-badge--primary position-absolute mr-1 m--hidden-tablet-and-mobile"
                              style="right: 0; top: 5px"
                            >
                              {{ property.Photos.length }}
                            </div>

                            <div v-else class="text-center">
                              <span class="img-cont no-logo">
                                <i
                                  class="la la-camera la-ban m--icon-font-size-lg3 d-block"
                                ></i>
                              </span>
                              <span class="d-block small">{{
                                $t("common.NoImages")
                              }}</span>
                            </div>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="
                              $t('Property.table.Id') +
                              ' / ' +
                              $t('Property.table.reference') +
                              ' / ' +
                              $t('Property.table.price')
                            "
                          >
                            <a
                              :href="
                                ts_url +
                                '/' +
                                userLang +
                                '/redirect-to-property/' +
                                property.Id +
                                '?preview=1'
                              "
                              target="_blank"
                            >
                              {{ property.Id }}
                            </a>
                            <br /><strong>{{ property.AgentRef }}</strong>
                            <br />
                            <span v-html="showPrice(property)"></span>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="
                              $t('Property.table.type') +
                              ' / ' +
                              $t('Property.table.offertype')
                            "
                          >
                            {{ property.Type && property.Type.Labels ? property.Type.Labels[userLang] : "-" }}
                            <br />
                            {{ property.OfferType && property.OfferType.Labels ? property.OfferType.Labels[userLang] : "-" }}
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.table.location')"
                          >
                            {{
                              property.Location.text[userLang]
                            }}
                          </td>
                          <td
                            class="align-middle text-left"
                            :data-thead-name="$t('Property.table.featured')"
                          >
                            <template v-if="hasServices">
                              <div class="pt-3">
                                <span
                                  class="m-switch m-switch--sm m-switch--icon m-switch--primary d-block"
                                  v-if="property.AdInfo.ThinkSpainFeaturedPremium"
                                  @click.stop.prevent="deactivateFeatured(property.Id)"
                                >
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked="checked"
                                      name=""
                                    />
                                    <span class="m-switch--label" style="white-space: pre;">Premium <template v-if="property.AdInfo.UpdatedBy == 'Auto'">{{ $t('property.autoFeatured') }}</template></span>
                                  </label>
                                </span>
                                <span
                                  class="m-switch m-switch--sm m-switch--icon d-block m-switch--grayed"
                                  v-if="!property.AdInfo.ThinkSpainFeaturedPremium && property.Online && hasFeaturedPremium"
                                  @click.stop.prevent="activateFeatured(property.Id, 'FeaturedPremium')"
                                >
                                  <label>
                                    <input type="checkbox" name="" />
                                    <span class="m-switch--label">Premium</span>
                                  </label>
                                </span>

                                <span
                                  class="m-switch m-switch--sm m-switch--icon d-block m-switch--success"
                                  v-if="property.AdInfo.ThinkSpainFeatured"
                                  @click.stop.prevent="deactivateFeatured(property.Id)"
                                >
                                  <label class="mb-0">
                                    <input
                                      type="checkbox"
                                      checked="checked"
                                      name=""
                                    />
                                    <span class="m-switch--label"  style="white-space: nowrap;"
                                      >Standard <template v-if="property.AdInfo.UpdatedBy == 'Auto'">{{ $t('property.autoFeatured') }}</template></span
                                    >

                                  </label>
                                </span>
                                <span
                                  class="m-switch m-switch--sm m-switch--icon m-switch--grayed d-block"
                                  v-if="!property.AdInfo.ThinkSpainFeatured && property.Online && hasFeaturedStandard"
                                  @click.stop.prevent="activateFeatured(property.Id, 'Featured')"
                                >
                                  <label class="mb-0">
                                    <input type="checkbox" name="" />
                                    <span class="m-switch--label"
                                      >Standard</span
                                    >
                                  </label>
                                </span>
                              </div>

                              <template
                                v-if="!hasFeaturedStandard && !hasFeaturedPremium"
                              >
                                <router-link
                                  :to="{ name: 'Advertise' }"
                                  class="activateService mt-2 d-block text-md-left"
                                >
                                  {{ $t("Directory.table.UpgradeToPremium") }}
                                </router-link>
                              </template>

                              <template v-if="!hasFeaturedPremium">
                                <router-link
                                  :to="{ name: 'Advertise' }"
                                  class="activateService mt-2 d-block text-md-left"
                                >
                                  {{ $t("Directory.table.UpgradeToPremium") }}
                                </router-link>
                              </template>
                            </template>
                            <template v-else>
                              <router-link
                                :to="{ name: 'Advertise' }"
                                class="activateService"
                              >
                                {{ $t("Directory.table.UpgradeToFeatured") }}
                              </router-link>
                            </template>

                            <div
                              class="m-separator dark m-separator--dashed my-4 d-block d-lg-none d-xl-none"
                            ></div>
                          </td>

                          <td
                            class="align-middle text-left position-relative actionBtnTd"
                          >
                            <a
                              href="javascript:"
                              :id="'actionBtn' + property.Id"
                              class="m-portlet__nav-link m-dropdown__toggle btn m-btn m-btn--link"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="true"
                            >
                              <i class="la la-ellipsis-h"></i>
                            </a>

                            <div
                              class="dropdown-menu m-dropdown__wrapper"
                              :aria-labelledby="'actionBtn' + property.Id"
                            >
                              <div class="px-1">
                                <ul class="m-nav">
                                  <li class="m-nav__item">
                                    <a
                                      href="javascript:"
                                      class="btn btn-brand m-btn btn-block m-btn--wide btn-sm"
                                      @click.prevent="editProperty(property)"
                                    >
                                      {{ $t("common.Edit") }}
                                    </a>
                                  </li>
                                  <li
                                    class="m-nav__item mt-1"
                                    v-if="!property.Suspended"
                                  >
                                    <a
                                      v-if="property.Status === 'active'"
                                      href="javascript:"
                                      @click="deactivate(property.Id)"
                                      class="btn m--font-light btn-warning m-btn btn-block m-btn--wide btn-sm"
                                    >
                                      {{ $t("common.Deactivate") }}
                                    </a>
                                    <a
                                      v-if="property.Status === 'deactivated'"
                                      href="javascript:"
                                      @click="activate(property.Id)"
                                      class="btn btn-success m-btn btn-block m-btn--wide btn-sm"
                                    >
                                      {{ $t("common.Activate") }}
                                    </a>
                                  </li>
                                  <li
                                    class="m-nav__item mt-1"
                                    v-if="isManualService"
                                  >
                                    <a
                                      @click="removeProperty(property.Id)"
                                      class="btn m--font-white btn-danger m-btn btn-block m-btn--wide btn-sm"
                                    >
                                      {{ $t("common.Delete") }}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="properties.length === 0">
                          <td
                            colspan="11"
                            class="text-center m--regular-font-size-lg3 py-3"
                          >
                            <template v-if="!loading">{{
                              this.$t("Property.table.NoRecordsFound")
                            }}</template>
                            <template v-else>{{
                              this.$t("common.sendingDataPleaseWait")
                            }}</template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="m-separator m-separator--dashed mt-2"></div>
                  </div>
                  <!--End: List Properties -->

                  <Pagination
                    :total-pages="pagination.totalPages"
                    :per-page="resultsPerPage"
                    :current-page="pagination.currentPage"
                    :loading="false"
                    @pagechanged="onPageChange"
                  >
                  </Pagination>
                </div>
              </div>
              <!--end: Portlet-->
            </div>
          </div>
          <!-- End:: LIST -->
        </div>
        <div
          class="modal fade"
          id="modalPropertyAdd"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modalPropertyAdd"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            class="modal-dialog modal-xl m-portlet--fullscreen"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" v-html="makeModalTitle"></h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-xl-12">
                    <!--begin: Form Wizard-->
                    <div
                      class="m-wizard m-wizard--5 m-wizard--brand m-wizard--step-first"
                      id="m_wizard"
                      v-bind:data-startStep="startTab"
                    >
                      <!--begin: Form Wizard Head -->
                      <div class="m-wizard__head">
                        <div class="row">
                          <div class="col-xl-12">
                            <!--begin: Form Wizard Nav -->
                            <div class="m-wizard__nav">
                              <div class="m-wizard__steps">
                                <div
                                  class="m-wizard__step m-wizard__step--current"
                                  :m-wizard-target="'m_wizard_form_step_1'"
                                >
                                  <div class="m-wizard__step-info">
                                    <a
                                      href="javascript:"
                                      class="m-wizard__step-number"
                                      @click.prevent="goToStep(1)"
                                    >
                                      <span class="m-wizard__step-seq">
                                        1.
                                      </span>
                                      <span class="m-wizard__step-label">
                                        {{ $t("common.Details") }}
                                      </span>
                                      <span class="m-wizard__step-icon">
                                        <i class="la la-check"></i>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                                <div
                                  class="m-wizard__step"
                                  :m-wizard-target="'m_wizard_form_step_2'"
                                >
                                  <div class="m-wizard__step-info">
                                    <a
                                      href="javascript:"
                                      class="m-wizard__step-number"
                                      @click.prevent="goToStep(2)"
                                    >
                                      <span class="m-wizard__step-seq">
                                        2.
                                      </span>
                                      <span class="m-wizard__step-label">
                                        {{ $t("common.Description") }}
                                      </span>
                                      <span class="m-wizard__step-icon">
                                        <i class="la la-check"></i>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                                <div
                                  class="m-wizard__step"
                                  :m-wizard-target="'m_wizard_form_step_3'"
                                >
                                  <div class="m-wizard__step-info">
                                    <a
                                      href="javascript:"
                                      class="m-wizard__step-number"
                                      @click.prevent="goToStep(3)"
                                    >
                                      <span class="m-wizard__step-seq">
                                        3.
                                      </span>
                                      <span class="m-wizard__step-label">
                                        {{ $t("common.PhotosMedia") }}
                                      </span>
                                      <span class="m-wizard__step-icon">
                                        <i class="la la-check"></i>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                                <div
                                  class="m-wizard__step"
                                  :m-wizard-target="'m_wizard_form_step_4'"
                                  @click.prevent="goToStep(4)"
                                >
                                  <div class="m-wizard__step-info">
                                    <a
                                      href="javascript:"
                                      class="m-wizard__step-number"
                                    >
                                      <span class="m-wizard__step-seq">
                                        4.
                                      </span>
                                      <span class="m-wizard__step-label">
                                        {{ $t("common.Confirmation") }}
                                      </span>
                                      <span class="m-wizard__step-icon">
                                        <i class="la la-check"></i>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--end: Form Wizard Nav -->
                          </div>
                        </div>
                      </div>
                      <!--end: Form Wizard Head -->

                      <!--begin: Form Wizard Form-->
                      <div class="m-wizard__form">
                        <form
                          class="m-form m-form--label-align-left- m-form--state-"
                          id="m_form"
                          novalidate="novalidate"
                        >
                          <div
                            class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-danger fade show mt-4"
                            role="alert"
                            v-if="!notEditProperty"
                          >
                            <div class="m-alert__icon">
                              <i class="flaticon-danger"></i>
                              <span></span>
                            </div>
                            <div class="m-alert__text">
                              <strong
                                >{{ $t("Property.form.Attention") }}:</strong
                              >
                              {{ $t("Property.ChangesSavedOnFinalStep") }}
                            </div>
                          </div>

                          <!--begin: Form Body -->
                          <div class="m-portlet__body">
                            <!--begin: Form Wizard Step 1-->
                            <div
                              class="m-wizard__form-step m-wizard__form-step--current"
                              id="m_wizard_form_step_1"
                            >
                              <div class="row">
                                <div class="col-xl-12">
                                  <div
                                    class="m-form__section m-form__section--first"
                                  >
                                    <div
                                      class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show mt-0"
                                      role="alert"
                                    >
                                      <div class="m-alert__icon">
                                        <i class="flaticon-exclamation-1"></i>
                                        <span></span>
                                      </div>
                                      <div class="m-alert__text">
                                        <strong
                                          >{{
                                            $t("Property.form.Note")
                                          }}:</strong
                                        >
                                        {{ $t("Property.form.NoteDesc") }}
                                      </div>
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      ></button>
                                    </div>

                                    <div class="row">
                                      <div
                                        class="col-xll-2 col-xl-2 col-md-6 col-sm-4"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t("Property.form.yourreference")
                                            }}: <small>(*)</small>
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              type="text"
                                              class="form-control m-input m-input--solid"
                                              :placeholder="
                                                $t(
                                                  'Property.form.yourreferencePlaceholder'
                                                )
                                              "
                                              v-model="property.AgentRef"
                                            />
                                            <label v-if="validated && !property.AgentRef" class="error">{{ $t("error.ThisFieldIsRequired") }}</label>
                                            <label v-if="validated && property.AgentRef && property.AgentRef.length > 100" class="error">{{ $t("error.FieldTooLong") }}</label>
                                            <span class="m-form__help">
                                              {{
                                                $t("Property.form.AgentRefDesc")
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xll-3 col-xl-3 col-md-6 col-sm-4"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.form.type") }}:
                                            <small>(*)</small>
                                          </label>
                                          <div class="col-xl-12">
                                            <v-select
                                              :options="propertyTypes"
                                              :get-option-label="option => option.Labels[userLang]"
                                              :clearable="false"
                                              v-model="property.Type"
                                              :placeholder="$t('common.select')"
                                              class="custom-select form-control m-input--solid noclose"
                                            >
                                            </v-select>
                                            <label v-if="validated && !property.Type" class="error">{{ $t("error.ThisFieldIsRequiredSuggested") }}</label>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xll-3 col-xl-3 col-md-4 col-sm-4"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.form.offertype") }}:
                                            <small>(*)</small>
                                          </label>
                                          <div class="col-xl-12">
                                            <v-select
                                              :searchable="false"
                                              :options="offerTypes"
                                              :get-option-label="option => option.Labels[userLang]"
                                              :clearable="false"
                                              :required="true"
                                              v-model="property.OfferType"
                                              :placeholder="$t('common.select')"
                                              class="custom-select form-control m-input--solid noclose"
                                            >
                                            </v-select>
                                            <label v-if="validated && !property.OfferType" class="error">{{ $t("error.ThisFieldIsRequiredSuggested") }}</label>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xll-1 col-xxl-1 col-xl-1 col-md-2 col-sm-2"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("common.Currency") }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <select
                                              name="currency"
                                              class="custom-select form-control m-input--solid"
                                              :placeholder="$t('common.select')"
                                              v-model="property.Currency"
                                            >
                                              <option value="EUR">
                                                &euro;
                                              </option>
                                              <option value="GBP">
                                                &pound;
                                              </option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-xxl col-xl col-md col-sm">
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            <template
                                              v-if="property.OfferType && property.OfferType.Id == 2"
                                            >
                                              {{
                                                $t("Property.table.priceMin")
                                              }}
                                              <span class="small">/ {{ $t("common.week") }}</span
                                              >: <small>(*)</small>
                                            </template>
                                            <template
                                              v-else-if="property.OfferType && property.OfferType.Id == 4"
                                            >
                                              {{ $t("Property.table.price") }}
                                              <span class="small">
                                                / {{ $t("common.month") }}</span
                                              >
                                            </template>
                                            <template v-else>
                                              {{ $t("Property.table.price") }}
                                            </template>
                                          </label>

                                          <div class="col-xl-12">
                                            <input
                                              min="0"
                                              max="999999999"
                                              type="number"
                                              pattern="\d*"
                                              step="1"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model.number="property.Price"
                                            />
                                            <label v-if="validated && !property.Price" class="error">{{ $t("error.ThisFieldIsRequired") }}</label>
                                            <label v-if="validated && property.Price && (property.Price.toString().includes(',') || property.Price.toString().includes('.') || (property.Price.toString().length > 9))" class="error">{{ $t("error.InvalidField") }}</label>
                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.WithoutDecimals"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xxl col-xl col-md col-sm"
                                        v-if="property.OfferType && property.OfferType.Id == 2"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.table.priceMax") }}
                                            <span class="small">
                                              / {{ $t("common.week") }}</span
                                            >:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              min="0"
                                              max="1000000000"
                                              type="number"
                                              pattern="\d*"
                                              step="1"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model.number="property.HighSeasonPrice"
                                            />
                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.WithoutDecimals"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="m-separator--dashed m-separator mb-3 m-separator--md"
                                    ></div>

                                    <div class="row">
                                      <div
                                        class="col-xl-2 col-md-6 col-sm-12 col-xs-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.form.CadastralReference.label"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              type="text"
                                              class="form-control m-input m-input--solid"
                                              name="CadastralReference"
                                              v-model="
                                                property.CadastralReference
                                              "
                                              :placeholder="
                                                $t(
                                                  'Property.form.CadastralReference.placeholder'
                                                )
                                              "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl-4 col-md-6 col-sm-12 col-xs-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.form.Location") }}:
                                            <small>(*)</small>
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <v-select
                                                @search="suggestPropertyLocations"
                                                :filterable="false"
                                                :options="suggestedPropertyLocations"
                                                v-model="property.Location"
                                                :placeholder="$t('common.Eg') + 'Denia, Alicante'"
                                                class="custom-select form-control m-input--solid noclose"
                                                label="name"
                                              >
                                                <template slot="selected-option" slot-scope="option">
                                                  {{ option.text[userLang] }}
                                                </template>
                                                <template slot="no-options">
                                                  <span v-if="suggestedPropertyLocationsText.length > 2">
                                                    {{ $t('common.NoMatchingLocations') }}
                                                  </span>
                                                  <span v-else>
                                                  </span>
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                  <p style="line-height: 22px;margin: 0px;padding:6px 0px 4px 6px;" v-html="formatSuggestedLocation( option, suggestedPropertyLocationsText )">
                                                  </p>
                                                </template>
                                              </v-select>
                                              </v-select>
                                              <label v-if="validated && !property.Location" class="error">{{ $t("error.ThisFieldIsRequired") }}</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl col-md-6 col-sm-12 col-xs-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.form.FullAddress.label"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              type="text"
                                              class="form-control m-input m-input--solid"
                                              id="Address"
                                              v-model="property.Address"
                                              :placeholder="$t(property.Location ? 'Property.form.FullAddress.placeholder' : 'Property.form.FullAddress.disabledtext')"
                                              :readonly="!property.Location"
                                            />

                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.FullAddress.helptext"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div
                                            class="col-12 pt-xl-2 pt-lg-2 pt-md-2 pt-sm-2 pt-xs-2 pt-2"
                                          >
                                            <label
                                              class="m-checkbox m-checkbox--solid m-checkbox--brand"
                                              :disabled="!property.Address"
                                            >
                                              <input
                                                type="checkbox"
                                                name="ShowAddress"
                                                v-model="showAddress"
                                                :disabled="!property.Address"
                                              />
                                              {{
                                                $t(
                                                  "Property.form.Coordinates.DisplayFullAddress"
                                                )
                                              }}
                                              <span></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="m-separator--dashed m-separator mb-3 m-separator--md"
                                    ></div>

                                    <div class="row">
                                      <div class="col-xl-4 col-md-12 col-sm-12">
                                        <div class="row">
                                          <div class="col-xl-12">
                                            <div class="row">
                                              <label
                                                class="col-xl-12 col-form-label"
                                              >
                                                {{
                                                  $t(
                                                    "Property.form.Coordinates.label"
                                                  )
                                                }}:
                                              </label>
                                              <div class="col-xl-6 col-sm-6">
                                                <div
                                                  class="input-group form-group"
                                                >
                                                  <div
                                                    class="input-group-prepend"
                                                  >
                                                    <span
                                                      class="input-group-text"
                                                      ><small>{{
                                                        $t(
                                                          "Property.form.Coordinates.latitude.shortlabel"
                                                        )
                                                      }}</small></span
                                                    >
                                                  </div>
                                                  <input
                                                    type="number"
                                                    inputmode="decimal"
                                                    name="Latitude"
                                                    class="form-control m-input m-input--solid"
                                                    :placeholder="
                                                      $t(
                                                        'Property.form.Coordinates.latitude.placeholder'
                                                      )
                                                    "
                                                    v-model.number="property.Latitude"
                                                    :readonly="!positionEdition"
                                                  />
                                                </div>
                                                <label v-if="validated && property.Latitude && (property.Latitude < 27.633 || property.Latitude > 44)" class="error">{{ $t("error.InvalidField") }}</label>
                                              </div>
                                              <div class="col-xl-6 col-sm-6">
                                                <div
                                                  class="input-group form-group"
                                                >
                                                  <div
                                                    class="input-group-prepend"
                                                  >
                                                    <span
                                                      class="input-group-text"
                                                      ><small>{{
                                                        $t(
                                                          "Property.form.Coordinates.longitude.shortlabel"
                                                        )
                                                      }}</small></span
                                                    >
                                                  </div>
                                                  <input
                                                    type="number"
                                                    inputmode="decimal"
                                                    name="Longitude"
                                                    class="form-control m-input m-input--solid"
                                                    :placeholder="
                                                      $t(
                                                        'Property.form.Coordinates.longitude.placeholder'
                                                      )
                                                    "
                                                    v-model.number="property.Longitude"
                                                    :readonly="!positionEdition"
                                                  />
                                                </div>
                                                <label v-if="validated && property.Longitude && (property.Longitude < -18.167 || property.Longitude > 6.033)" class="error">{{ $t("error.InvalidField") }}</label>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="col-xl-12">
                                            <button
                                              type="button"
                                              class="btn btn-brand btn-sm mb-1 btn-sm-block btn-md-inline-block"
                                              :disabled="!property.Address"
                                              @click="
                                                getLatLngFromAddress($event)
                                              "
                                            >
                                              <i class="la la-map-marker"></i>
                                              {{
                                                $t(
                                                  "Property.form.coordinateButtons.useAddressField"
                                                )
                                              }}
                                            </button>
                                            <button
                                              type="button"
                                              class="btn btn-brand btn-sm mb-1"
                                              @click="
                                                getCurrentLocation($event)
                                              "
                                            >
                                              <i class="la la-map-marker"></i>
                                              {{
                                                $t(
                                                  "Property.form.coordinateButtons.useMyLocation"
                                                )
                                              }}
                                            </button>
                                            <button
                                              type="button"
                                              class="btn btn-brand btn-sm mb-1"
                                              @click="toggleAddEdit"
                                            >
                                              <i class="la la-map-marker"></i>
                                              {{
                                                $t(
                                                  "Property.form.coordinateButtons.addEdit"
                                                )
                                              }}
                                            </button>
                                            <button
                                              type="button"
                                              class="btn btn-danger btn-sm mb-1"
                                              @click="clearCoord"
                                            >
                                              <i class="la la-map-marker"></i>
                                              {{
                                                $t(
                                                  "Property.form.coordinateButtons.clear"
                                                )
                                              }}
                                            </button>
                                          </div>
                                          <template
                                            v-if="
                                              property.Latitude &&
                                              property.Longitude
                                            "
                                          >
                                            <div class="col-12 pt-2">
                                              <label class="row col-form-label">
                                                <span class="col-12">
                                                  {{
                                                    $t(
                                                      "Property.form.Coordinates.explanation"
                                                    )
                                                  }}: <small>(*)</small>
                                                </span>
                                              </label>
                                            </div>
                                            <div class="col-xl-12">
                                              <div
                                                class="m-form__group form-group"
                                                id="GeoInfo"
                                              >
                                                <label
                                                  class="m-radio m-radio--solid m-radio--brand d-block"
                                                >
                                                  <input
                                                    type="radio"
                                                    name="GeoInfo"
                                                    value="exact"
                                                    v-model="property.GeoInfo"
                                                  />{{
                                                    $t(
                                                      "Property.form.Coordinates.radiobtn.exactLocation"
                                                    )
                                                  }}
                                                  <span></span>
                                                </label>
                                                <label
                                                  class="m-radio m-radio--solid m-radio--brand d-block"
                                                >
                                                  <input
                                                    type="radio"
                                                    name="GeoInfo"
                                                    value="street"
                                                    v-model="property.GeoInfo"
                                                  />
                                                  {{
                                                    $t(
                                                      "Property.form.Coordinates.radiobtn.streetLocation"
                                                    )
                                                  }}
                                                  <span></span>
                                                </label>
                                                <label
                                                  class="m-radio m-radio--solid m-radio--brand d-block"
                                                >
                                                  <input
                                                    type="radio"
                                                    name="GeoInfo"
                                                    value="approx"
                                                    v-model="property.GeoInfo"
                                                  />
                                                  {{
                                                    $t(
                                                      "Property.form.Coordinates.radiobtn.approxLocation"
                                                    )
                                                  }}
                                                  <span></span>
                                                </label>
                                                <label
                                                  class="m-radio m-radio--solid m-radio--brand d-block"
                                                >
                                                  <input
                                                    type="radio"
                                                    name="GeoInfo"
                                                    value="town"
                                                    v-model="property.GeoInfo"
                                                  />
                                                  {{
                                                    $t(
                                                      "Property.form.Coordinates.radiobtn.townLocation"
                                                    )
                                                  }}
                                                  <span></span>
                                                </label>
                                                <label v-if="validated && !property.GeoInfo" class="error">{{ $t("error.ThisFieldIsRequired") }}</label>

                                              </div>
                                            </div>
                                          </template>
                                        </div>
                                      </div>

                                      <div class="col-xl col-md-12 col-sm-12">
                                        <label
                                          class="col-xl-12 col-form-label m--hidden-tablet-and-mobile"
                                        >
                                        </label>

                                        <template
                                          v-if="
                                            property.Latitude &&
                                            property.Longitude
                                          "
                                        >
                                          <gmap-map
                                            ref="myMap"
                                            :center="position"
                                            :zoom="17"
                                            :options="gMapOptions"
                                            style="width: 100%; height: 300px"
                                          >
                                            <gmap-marker
                                              v-if="position"
                                              :position="position"
                                              @click="center = position"
                                              :options="gPinOptions"
                                              @dragend="positionMoved"
                                            >
                                            </gmap-marker>
                                          </gmap-map>

                                          <div class="col-xl-12 mt-2">
                                            <span class="m-form__help">
                                              <i class="la la-map-marker"></i>
                                              {{
                                                $t("Property.form.map.helptext")
                                              }}
                                            </span>
                                          </div>
                                        </template>

                                        <template v-else>
                                          <div class="row">
                                            <div class="col-xl-12">
                                              <div
                                                class="col-xl-12 m-stack m-stack--ver m-stack--general px-0"
                                              >
                                                <div
                                                  class="col-xl-12 card text-center m-stack__item m-stack__item--center m-stack__item--middle"
                                                  style="height: 300px"
                                                >
                                                  <label
                                                    class="col-xl-12 col-form-label m-stack__item m-stack__item--center m-stack__item--middle"
                                                  >
                                                    <i
                                                      class="la la-map m--icon-font-size-lg2 d-block"
                                                    ></i>
                                                    {{
                                                      $t(
                                                        "Property.form.map.helptext2"
                                                      )
                                                    }}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </template>
                                      </div>
                                    </div>

                                    <div
                                      class="m-separator--dashed m-separator mb-2 m-separator--md"
                                    ></div>

                                    <!-- begin: bedrooms + baths + toilets + plot + livingarea -->
                                    <div class="row">
                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t("Property.Analytics.bedrooms")
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              min="0"
                                              type="number"
                                              step="1"
                                              name="Bedrooms"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model.number="property.Bedrooms"
                                            />
                                            <label v-if="validated && property.Bedrooms && (property.Bedrooms.toString().includes(',') || property.Bedrooms.toString().includes('.'))" class="error">{{ $t("error.InvalidField") }}</label>
                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.WithoutDecimals"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.Analytics.bathrooms"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              type="number"
                                              pattern="\d*"
                                              step="1"
                                              name="Bathrooms"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model.number="property.Bathrooms"
                                            />
                                            <label v-if="validated && property.Bathrooms && (property.Bathrooms.toString().includes(',') || property.Bathrooms.toString().includes('.'))" class="error">{{ $t("error.InvalidField") }}</label>
                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.WithoutDecimals"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t("Property.Analytics.toilets")
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              type="number"
                                              pattern="\d*"
                                              step="1"
                                              name="Toilets"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model.number="property.Toilets"
                                            />
                                            <label v-if="validated && property.Toilets && (property.Toilets.toString().includes(',') || property.Toilets.toString().includes('.'))" class="error">{{ $t("error.InvalidField") }}</label>
                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.WithoutDecimals"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.form.Plot") }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="Plot"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="property.Plot"
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small
                                                    >m<sup>2</sup></small
                                                  ></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t("Property.form.LivingArea")
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="Build"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="property.Build"
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small
                                                    >m<sup>2</sup></small
                                                  ></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.Analytics.floornum.label"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              type="text"
                                              name="FloorNumber"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model="property.FloorNumber"
                                              maxlength="20"
                                            />
                                            <label v-if="validated && property.FloorNumber && (property.FloorNumber.length > 20)" class="error">{{ $t("error.InvalidField") }}</label>
                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.Analytics.floornum.helptext"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.Analytics.numberoffloors"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              min="0"
                                              type="number"
                                              pattern="\d*"
                                              step="1"
                                              name="Levels"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model.number="property.Levels"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.Analytics.yearBuild"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <input
                                              min="1900"
                                              type="number"
                                              step="1"
                                              name="YearBuilt"
                                              class="form-control m-input m-input--solid"
                                              placeholder=""
                                              v-model.number="property.YearBuilt"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.form.EnergyRatingConsumption"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <v-select
                                              :options="energyRatings"
                                              :id="'EnergyRatingConsumption'"
                                              :clearable="true"
                                              :searchable="false"
                                              :label="'label'"
                                              v-model="
                                                property.EnergyRatingConsumption
                                              "
                                              :placeholder="$t('common.select')"
                                              class="custom-select form-control m-input--solid noclose"
                                            >
                                            </v-select>

                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.EnergyRatingConsumptionDesc"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-xl-2 col-md-6 col-sm-6 col-12"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.form.EnergyRatingEmissions"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <v-select
                                              :options="energyRatings"
                                              :clearable="true"
                                              :searchable="false"
                                              v-model="
                                                property.EnergyRatingEmissions
                                              "
                                              :placeholder="$t('common.select')"
                                              class="custom-select form-control m-input--solid noclose"
                                            >
                                            </v-select>

                                            <span class="m-form__help">
                                              {{
                                                $t(
                                                  "Property.form.EnergyRatingEmissionsDesc"
                                                )
                                              }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="m-separator--dashed m-separator mb-2 m-separator--md"
                                    ></div>

                                    <!-- begin: garage + pool + aircond + centralheat -->
                                    <div class="row pt-4">
                                      <div class="col">
                                        <ul class="ts-checktags">
                                          <li
                                            v-for="(feature, index) in features"
                                            :key="index"
                                          >
                                            <input
                                              :id="'feature-' + feature.value"
                                              type="checkbox"
                                              :value="feature.value"
                                              v-model="property.Features"
                                            />
                                            <label
                                              :for="'feature-' + feature.value"
                                              class="ts-checktags-label"
                                              >{{
                                                feature.Labels[(userLang)]
                                              }}</label
                                            >
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="m-form__section">
                                    <div class="m-form__heading">
                                      <h3 class="m-form__heading-title">
                                        {{ $t("common.DistanceKM") }}
                                      </h3>

                                      <div
                                        class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show mt-4"
                                        role="alert"
                                      >
                                        <div class="m-alert__icon">
                                          <i class="flaticon-exclamation-1"></i>
                                          <span></span>
                                        </div>
                                        <div class="m-alert__text">
                                          <strong
                                            >{{
                                              $t("Property.form.Note")
                                            }}:</strong
                                          >
                                          {{ $t("Property.form.NoteDesc2") }}
                                        </div>
                                        <button
                                          type="button"
                                          class="close"
                                          data-dismiss="alert"
                                          aria-label="Close"
                                        ></button>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        class="col-xl col-md-4 col-sm-6 col-6"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t("Property.form.NearestTown")
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="DistanceToTown"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="
                                                  property.DistanceToTown
                                                "
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small>km</small></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl col-md-4 col-sm-6 col-6"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.form.NearestAirport"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="DistanceToAirport"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="
                                                  property.DistanceToAirport
                                                "
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small>km</small></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl col-md-4 col-sm-6 col-6"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.form.Marina") }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="DistanceToMarina"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="
                                                  property.DistanceToMarina
                                                "
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small>km</small></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl col-md-4 col-sm-6 col-6"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.form.Beach") }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="DistanceToBeach"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="
                                                  property.DistanceToBeach
                                                "
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small>km</small></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl col-md-4 col-sm-6 col-6"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{
                                              $t(
                                                "Property.form.CountryMountains"
                                              )
                                            }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="DistanceToCountry"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="
                                                  property.DistanceToCountry
                                                "
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small>km</small></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col-xl col-md-4 col-sm-6 col-6"
                                      >
                                        <div class="row">
                                          <label
                                            class="col-xl-12 col-form-label"
                                          >
                                            {{ $t("Property.form.Golf") }}:
                                          </label>
                                          <div class="col-xl-12">
                                            <div class="input-group">
                                              <input
                                                type="number"
                                                step="0.01"
                                                inputmode="decimal"
                                                name="DistanceToGolf"
                                                class="form-control m-input m-input--solid"
                                                placeholder=""
                                                v-model.number="
                                                  property.DistanceToGolf
                                                "
                                              />
                                              <div class="input-group-append">
                                                <span class="input-group-text"
                                                  ><small>km</small></span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--end: Form Wizard Step 1-->

                            <!--begin: Form Wizard Step 2-->
                            <div
                              class="m-wizard__form-step"
                              id="m_wizard_form_step_2"
                            >
                              <div class="row">
                                <div class="col-xl-12">
                                  <ul class="ts-checktags">
                                    <li
                                      v-for="(language, index) in languages"
                                      :key="index"
                                    >
                                      <input
                                        :id="'language-' + language.code"
                                        type="checkbox"
                                        :checked="languageInEdit == language.code"
                                        @click="languageInEdit = language.code"
                                      />
                                      <label
                                        :for="'language-' + language.code"
                                        class="ts-checktags-label"
                                        >
                                          <svg style="float: left; margin-right: 5px;" v-if="!property.Descriptions[language.code]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="statusDesc">
                                            <circle fill="none" property.Desc="" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" class="path circle show"></circle>
                                            <line fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" class="path line show"></line> <line fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" class="path line show"></line>
                                          </svg>
                                          <svg style="float: left; margin-right: 5px;" v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="statusDesc"><circle fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" class="path circle show"></circle> <polyline fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " class="path check show"></polyline></svg>
                                        {{ $t('language.' + language.code) }}</label
                                      >
                                    </li>
                                  </ul>
                                  <div class="form-group row m-form__group" >
                                    <div class="col-xl-12 px-0 pt-2">
                                      <div class="col-xl-12 px-1" v-for="(language, index) in languages" :key="index">
                                        <template v-if="languageInEdit == language.code">
                                        <h3 class="m-portlet__head-text">{{ $t('language.' + language.code) }}</h3>
                                        <textarea
                                          rows="10"
                                          class="form-control m-input m-input--solid mb-2"
                                          v-model="property.Descriptions[language.code]"
                                          :placeholder="
                                            $t(
                                              'common.PleaseEnterADescription',
                                              {
                                                language: $t(
                                                  'language.' +
                                                    language.code
                                                ),
                                              }
                                            )
                                          "
                                          :name="language.code"
                                        ></textarea>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--end: Form Wizard Step 2-->

                            <!--begin: Form Wizard Step 3-->
                            <div
                              class="m-wizard__form-step"
                              id="m_wizard_form_step_3"
                            >
                              <div class="row">
                                <div class="col-xl-12">

                                  <div class="row">

                                    <div class="col-12 col-md-6 ui-sortable" id="m_sortable_portlets">
                                      <div class="row" v-if="property.Photos && property.Photos.length < limitFoto">
                                        <div class="col">
                                          <div class="m-portlet  m-portlet--head-sm">
                                            <div class="m-portlet__head">
                                              <div class="m-portlet__head-caption">
                                                <div class="m-portlet__head-title">
                                                  <span class="m-portlet__head-icon m--hide">
                                                      <i class="la la-gear"></i>
                                                  </span>
                                                  <h3 class="m-portlet__head-text">
                                                    {{$t('common.uploadImage')}}
                                                  </h3>
                                                </div>
                                              </div>
                                              <div class="m-portlet__head-tools">
                                                <h5 class="pt-2">{{property.Photos?property.Photos.length:0}}/{{limitFoto}}</h5>
                                              </div>
                                            </div>
                                            <form enctype='multipart/form-data'
                                                  class="m-form m-form--fit m-form--label-align-right" @submit.prevent="submitFile()">
                                              <div class="m-portlet__body">

                                                <div class=" m-form__group">
                                                  <div class="alert m-alert alert-info m-alert--outline mb-4" role="alert">
                                                    {{$t('common.maxfilesize')}}.
                                                  </div>
                                                  <div class="row">
                                                    <div class="col-lg-12">
                                                      <div class="custom-file">
                                                        <input type="file" class="custom-file-input" multiple id="file" @change="onFileChange" accept="image/*">
                                                        <label class="custom-file-label" for="file" :data-label="$t('common.chooseFiles')"> {{$t('common.chooseFiles')}}</label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col">

                                          <draggable v-if="property.Photos && property.Photos.length" v-model="property.Photos"
                                            @update="updateImageList" :sort="true">

                                            <div v-for='(photo, index) in property.Photos' :key="index"
                                              class="m-portlet m-portlet--mobile m-portlet--sortable m-portlet--head-sm photo-item">

                                              <div class="m-portlet__head ui-sortable-handle">
                                                <div class="m-portlet__head-caption">
                                                  <div class="m-portlet__head-title">
                                                  <span class="m-portlet__head-icon">
                                                      <i class="la la-photo m--font-brand"></i>
                                                  </span>
                                                    <h3 class="m-portlet__head-text m--font-brand">
                                                      {{ getFilename(photo.Url) }}
                                                    </h3>
                                                  </div>
                                                </div>
                                                <div class="m-portlet__head-tools">
                                                  <div class="counter"></div>
                                                </div>
                                              </div>
                                              <div class="m-portlet__body">
                                                <div class="tab-pane active">
                                                  <div class="m-widget4 m-widget4--progress">
                                                    <div class="m-widget4__item">

                                                      <div class="m-widget4__img">
                                                        <div class="ratio-4-3-padding">
                                                          <img :src="photo.Url" :data-cdnurl="formatCdnPath(photo.CdnUrl)"
                                                              @error="setAltImageFromCdnUrl"
                                                          >
                                                        </div>
                                                      </div>

                                                      <div class="m-widget4__ext pl-lg-5 pl-md-5 pl-sm-3 pl-2">
                                                        <ul class="m-portlet__nav list-unstyled list-inline mt-2">
                                                          <li class="m-portlet__nav-item list-inline-item">

                                                            <a href="javascript:" v-if="index > 0 && index < property.Photos.length"
                                                               class="m-portlet__nav-link btn btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--pill m-btn--hover-brand"
                                                               @click.prevent="movePhotoUp(index)">

                                                              <i class="la la-arrow-up"></i>
                                                            </a>
                                                          </li>
                                                          <li class="m-portlet__nav-item list-inline-item">

                                                            <a href="javascript:" v-if="(index + 1) < property.Photos.length"
                                                               class="m-portlet__nav-link btn btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--pill m-btn--hover-brand"
                                                               @click.prevent="movePhotoDown(index)">

                                                              <i class="la la-arrow-down"></i>
                                                            </a>
                                                          </li>
                                                        </ul>

                                                        <a href="javascript:"
                                                           class="m-btn btn-block m-btn--hover-danger m-btn--pill btn btn-secondary ws-nowrap"
                                                           @click.prevent="deleteImage(index)"><i class="la la-trash"></i> {{$t('common.Delete')}}</a>

                                                      </div>

                                                    </div>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </draggable>

                                          <div v-else class="m-stack m-stack--ver m-stack--general">
                                            <h4 class="m-stack__item m-stack__item--center m-stack__item--middle">
                                              <i class="la la-camera m--icon-font-size-lg5"></i>
                                              <span class="d-block">{{$t('common.nophotosuploaded')}}</span>
                                            </h4>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="row" v-if="property.Photos && property.Photos.length > 2 && property.Photos.length < limitFoto">
                                        <div class="col">
                                          <div class="m-portlet  m-portlet--head-sm">
                                            <form enctype='multipart/form-data'
                                                  class="m-form m-form--fit m-form--label-align-right" @submit.prevent="submitFile()">
                                              <div class="m-portlet__body">

                                                <div class=" m-form__group">
                                                  <div class="alert m-alert alert-info m-alert--outline mb-4" role="alert">
                                                    {{$t('common.maxfilesize')}}.
                                                  </div>
                                                  <div class="row">
                                                    <div class="col-lg-12">
                                                      <div class="custom-file">
                                                        <input type="file" class="custom-file-input" multiple id="file" @change="onFileChange" accept="image/*">
                                                        <label class="custom-file-label" for="file" :data-label="$t('common.chooseFiles')"> {{$t('common.chooseFiles')}}</label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                      <div class="row">
                                        <div class="col">
                                          <div class="m-portlet  m-portlet--head-sm">
                                            <div class="m-portlet__head">
                                              <div class="m-portlet__head-caption">
                                                <div class="m-portlet__head-title">
                                                  <span class="m-portlet__head-icon m--hide">
                                                      <i class="la la-gear"></i>
                                                  </span>
                                                  <h3 class="m-portlet__head-text">
                                                    {{$t('common.Media Links')}}
                                                  </h3>
                                                </div>
                                              </div>
                                            </div>
                                            <div  class="m-form m-form--fit m-form--label-align-right">
                                              <div class="m-portlet__body">

                                                <div class=" m-form__group">
                                                  <div class="row">
                                                    <div class="col-lg-8">
                                                      <div class="input-group form-group">
                                                        <div class="input-group-prepend">
                                                          <button class="input-group-button btn btn-default" @click.prevent="openLink(mediaUrl)" :disabled="!mediaUrl">
                                                            <i class="la la-eye"></i>
                                                          </button>
                                                        </div>
                                                        <input
                                                          type="text"
                                                          name="MediaURL"
                                                          class="form-control m-input m-input--solid"
                                                          v-model="mediaUrl"
                                                          placeholder="e.g. https://youtu.be/168fQPJQ62637T44">
                                                      </div>
                                                    </div>

                                                    <div class="col-lg-4">
                                                     <v-select
                                                       :options="mediaTypes"
                                                       :clearable="false"
                                                       :searchable="false"
                                                       v-model="mediaType"
                                                       class="custom-select form-control m-input--solid noclose"
                                                     >
                                                      </v-select>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="m-portlet__foot">
                                                <div class="row">
                                                  <div class="col-lg-12">
                                                    <button class="btn btn-primary" @click.prevent="addMedia()">Add Media</button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col">
                                          <div class="m-stack m-stack--ver m-stack--general"  v-if="!property.Medias || property.Medias.length == 0">
                                            <h4 class="m-stack__item m-stack__item--center m-stack__item--middle">
                                              <i class="la la-external-link m--icon-font-size-lg5"></i>
                                              <span class="d-block">{{$t('common.nomedialinksuploaded')}}</span>
                                            </h4>
                                          </div>
                                          <div v-else
                                          v-for="(media, index) in property.Medias" :key="index" class="m-portlet  m-portlet--head-sm">
                                             <div class="m-portlet__head" v-if="media">
                                              <div class="m-portlet__head-caption">
                                                <div class="m-portlet__head-title">
                                                  <span class="m-portlet__head-icon m--hide">
                                                      <i class="la la-gear"></i>
                                                  </span>
                                                  <span class="m-portlet__head-icon" v-html="showMediaIcon(media.type)">

                                                  </span>
                                                </div>
                                              </div>
                                              <div class="m-portlet__head-tools">
                                                <h6 class="pt-2"><a :href="media.url" target="_blank">{{ media.url}}</a></h6>
                                              </div>
                                            </div>
                                            <div class="m-portlet__foot">
                                              <div class="row">
                                                  <a @click="removeMedia(index)" href="javascript:" class="m-btn m-btn--hover-danger m-btn--pill btn btn-secondary ws-nowrap">
                                                    <i class="la la-trash"></i> Delete
                                                  </a>
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--end: Form Wizard Step 3-->

                            <!--begin: Form Wizard Step 4-->
                            <div
                              class="m-wizard__form-step"
                              id="m_wizard_form_step_4"
                            >
                              <div class="row">
                                <div class="col-xl-12">
                                  <div class="row">
                                    <div class="col-lg-3">
                                      <div class="m-form__section">
                                        <div class="m-form__heading">
                                          <h3 class="m-form__heading-title">
                                            {{$t('common.Details')}} <a href="javascript:" @click="goToStep(1)"><i class="la la-pencil"></i></a>
                                          </h3>
                                        </div>
                                        <div class="form-group m-form__group row pt-1">
                                          <div class="col-lg-12">
                                            <ul class="m-nav">
                                              <li class="m-nav__item">
                                                <label class="m--font-boldest">
                                                  <strong>{{property.AgentRef}}</strong>
                                                </label>
                                              </li>
                                              <li class="m-nav__item">
                                                <label class="form-control-label" v-if="property.Type && property.OfferType">{{ property.Type.Labels[userLang] + ' ' + property.OfferType.Labels[userLang] }}</label>
                                              </li>
                                              <li class="m-nav__item">
                                                <label class="form-control-label" v-html="showPrice(property)"></label>
                                              </li>
                                              <li class="m-nav__item" v-if="property.CadastralReference">
                                                <label class="form-control-label">
                                                  {{ $t("Property.form.CadastralReference.label") }}
                                                </label>
                                                <span>{{property.CadastralReference}}</span>
                                              </li>
                                              <li class="m-nav__item" v-if="property.Address || property.Location">
                                                <label class="form-control-label"><i class="la la-location-arrow"></i>
                                                  <span v-if="property.Address">{{property.Address}},</span>
                                                  <span v-if="property.Location">{{ property.Location.text[userLang] }}</span></label>
                                              </li>

                                              <li class="m-nav__item" v-if="property.Latitude && property.Longitude">
                                                <label class="form-control-label"><i class="la la-map-marker"></i> {{property.Latitude}}, {{property.Longitude}}</label>
                                              </li>
                                              <li class="m-nav__item mt-n3 mb-4" v-if="property.Latitude && property.Longitude">
                                                <label class="form-control-label mt-2">
                                                  <span class="m-alert__text m--regular-font-size-sm1">
                                                    <i>({{locationsTexts(property.GeoInfo)}})</i>
                                                  </span>

                                                </label>
                                              </li>
                                            </ul>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-6" v-if="hasFeatures">
                                      <div class="m-form__section">
                                        <div class="m-form__heading">
                                          <h3 class="m-form__heading-title">
                                            {{$t('common.Features')}} <a href="javascript:" @click="goToStep(1)"><i class="la la-pencil"></i></a>
                                          </h3>
                                        </div>
                                        <div class="form-group m-form__group row pt-1">
                                          <div class="col-lg-12">
                                            <ul :class="{'m-nav':true, 'col2':countFeatures >= 4 && countFeatures < 9, 'col3': countFeatures >= 9}">

                                              <li class="m-nav__item" v-if="property.Bedrooms">
                                                <label class="form-control-label">
                                                  {{$t('Property.form.bedrooms')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.Bedrooms}}</h6>
                                              </li>
                                              <li class="m-nav__item" v-if="property.Bathrooms">
                                                <label class="form-control-label">
                                                  {{$t('Property.form.bathrooms')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.Bathrooms}}</h6>
                                              </li>
                                              <li class="m-nav__item" v-if="property.Toilets">
                                                <label class="form-control-label">
                                                  {{$t('Property.form.toilets')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.Toilets}}</h6>
                                              </li>

                                              <li class="m-nav__item" v-if="property.Plot">
                                                <label class="form-control-label">
                                                  {{$t('Property.form.Plot')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.Plot}}m<sup>2</sup></h6>
                                              </li>
                                              <li class="m-nav__item" v-if="property.Build">
                                                <label class="form-control-label">
                                                  {{$t('Property.form.LivingArea')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.Build}}m<sup>2</sup></h6>
                                              </li>


                                              <li class="m-nav__item" v-if="property.FloorNumber">
                                                <label class="form-control-label">
                                                  {{$t('Property.Analytics.floornum.label')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.FloorNumber}}</h6>
                                              </li>

                                              <li class="m-nav__item" v-if="property.Levels">
                                                <label class="form-control-label">
                                                  {{$t('Property.Analytics.numberoffloors')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.Levels}}</h6>
                                              </li>

                                              <li class="m-nav__item" v-if="property.YearBuilt">
                                                <label class="form-control-label">
                                                  {{$t('Property.Analytics.yearBuild')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.YearBuilt}}</h6>
                                              </li>

                                              <li class="m-nav__item" v-if="property.EnergyRatingConsumption">
                                                <label class="form-control-label">
                                                  {{$t('Property.Analytics.EnergyRatingConsumption ')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.EnergyRatingConsumption}}</h6>
                                              </li>

                                              <li class="m-nav__item" v-if="property.EnergyRatingEmissions">
                                                <label class="form-control-label">
                                                  {{$t('Property.Analytics.EnergyRatingConsumption ')}}:
                                                </label>
                                                <h6 class="ml-1 d-inline">{{property.EnergyRatingEmissions}}</h6>
                                              </li>


                                              <li class="m-nav__item" v-for="(feature, index) in property.Features" :key="index">
                                                <label class="form-control-label">
                                                  {{ labelForFeature(feature) }}
                                                </label>

                                              </li>
                                            </ul>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-lg-3" v-if="locations">
                                      <div class="m-form__section">
                                        <div class="m-form__heading">
                                          <h3 class="m-form__heading-title">
                                            {{$t('common.DistanceKM')}} <a href="javascript:" @click="goToStep(1)"><i
                                            class="la la-pencil"></i></a>
                                          </h3>
                                        </div>
                                        <div class="form-group m-form__group row pt-1">
                                          <div class="col-lg-12">
                                            <ul class="m-nav">
                                              <li class="m-nav__item" v-if="property.DistanceToTown">
                                                <h6 class="ml-1 d-inline">{{property.DistanceToTown}}</h6>
                                                <label class="form-control-label">
                                                  {{$t('Property.form.kmto.town')}}
                                                </label>
                                              </li>
                                              <li class="m-nav__item" v-if="property.DistanceToAirport">

                                                <h6 class="ml-1 d-inline">{{property.DistanceToAirport}}</h6>
                                                <label class="form-control-label">
                                                  {{$t('Property.form.kmto.airport')}}
                                                </label>

                                              </li>
                                              <li class="m-nav__item" v-if="property.DistanceToMarina">
                                                <h6 class="ml-1 d-inline">{{property.DistanceToMarina}}</h6>
                                                <label class="form-control-label">
                                                  {{$t('Property.form.kmto.marina')}}
                                                </label>
                                              </li>

                                              <li class="m-nav__item" v-if="property.DistanceToBeach">
                                                <h6 class="ml-1 d-inline">{{property.DistanceToBeach}}</h6>
                                                <label class="form-control-label">
                                                  {{$t('Property.form.kmto.beach')}}
                                                </label>
                                              </li>

                                              <li class="m-nav__item" v-if="property.DistanceToCountry">
                                                <h6 class="ml-1 d-inline">{{property.DistanceToCountry}}</h6>
                                                <label class="form-control-label">
                                                  {{$t('Property.form.kmto.country')}}
                                                </label>
                                              </li>
                                               <li class="m-nav__item" v-if="property.DistanceToGolf">
                                                <h6 class="ml-1 d-inline">{{property.DistanceToGolf}}</h6>
                                                <label class="form-control-label">
                                                  {{$t('Property.form.kmto.golf')}}
                                                </label>
                                              </li>
                                            </ul>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col">
                                      <div class="col-lg m-separator m-separator--dashed"></div>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col-lg-12">
                                      <div class="m-form__section m-form__section">
                                        <div class="m-form__heading">

                                          <h3 class="m-form__heading-title">
                                            {{$t('Property.form.Descriptions')}} <a href="javascript:" @click="goToStep(2)"><i
                                            class="la la-pencil"></i></a>
                                          </h3>
                                        </div>
                                        <div class="form-group m-form__group row pt-0">

                                          <div class="col-lg-12">
                                            <div class="m-portlet m-portlet--tabs m-portlet--unair m-portlet--head-sm mb-0">
                                              <div class="m-portlet__body pl-1 pt-3 pb-0">
                                                <div class="row">

                                                  <div v-for="language in languages" :key="language.code" class="col-lg-6 col-12 col-md-12 col-xs-12 mb-4">
                                                    <h6 class="mb-4">{{$t('language.'+language.code)}} <small>[{{language.code}}]</small></h6>

                                                      <span v-if="property.Descriptions && !property.Descriptions[language.code]" class="my-2 d-block m-alert m-alert--outline alert alert-danger fade show" role="alert">
                                                        <span v-html="$t('Property.form.noDescFilledIn', {language: $t('language.'+language.code)})"></span>
                                                      </span>
                                                      <span v-else-if="property.Descriptions">
                                                        {{ property.Descriptions[language.code] }}
                                                      </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col">
                                      <div class="col-lg m-separator m-separator--dashed"></div>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="m-form__section m-form__section--first col">
                                      <div class="m-form__heading">
                                        <h3 class="m-form__heading-title">
                                          Photos <a href="javascript:" @click="goToStep(3)"><i class="la la-pencil"></i></a>
                                        </h3>
                                      </div>
                                      <div class="form-group m-form__group row">

                                        <div v-if="property.Photos && property.Photos.length === 0" class="col-xl col-lg-4 col-md-4 col-sm-6 col-xs-12 col mb-3">

                                          <div class="mt-4 m-alert m-alert--outline alert alert-danger fade show" role="alert">
                                            <strong>No Photos Uploaded</strong> Please upload up to 10 photos to get better results
                                          </div>
                                        </div>

                                        <div v-else
                                            class="w-20 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-12 col-12 col mb-4" v-for="(photo, index) in property.Photos" :key="index">

                                          <div class="m-widget4__img">
                                            <div class="ratio-4-3-padding">
                                              <img
                                                :src="photo.Url" :data-cdnurl="formatCdnPath(photo.CdnUrl)"
                                                @error="setAltImageFromCdnUrl"
                                              >
                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="m-separator m-separator--dashed"></div>

                                  <div class="row">
                                    <div class="col-lg-12">
                                      <div class="m-form__section m-form__section">
                                        <div class="m-form__heading">
                                          <h3 class="m-form__heading-title">
                                            {{$t('common.Media')}} <a href="javascript:" @click="goToStep(3)"><i
                                            class="la la-pencil"></i></a>
                                          </h3>
                                        </div>
                                        <div class="form-group m-form__group row pt-0">

                                          <div class="col-lg-12">
                                            <div class="m-portlet m-portlet--tabs m-portlet--unair m-portlet--head-sm mb-0">
                                              <div class="m-portlet__body pl-1 pt-3 pb-0">
                                                <div class="row">
                                                  <template v-if="property.Medias">
                                                     <div v-for="(media, index) in property.Medias" :key="index" class="col-lg-6 col-12 col-md-12 col-xs-12 mb-4">
                                                        <h6 class="mb-4"><span class="m-portlet__head-icon" v-html="showMediaIcon(media.type)"></span> {{media.url}}</h6>
                                                     </div>
                                                  </template>
                                                  <template v-else>
                                                    <div class="col-12">
                                                      <div class="mt-1 m-alert m-alert--outline alert alert-danger fade show" role="alert">
                                                        {{$t('common.nomedialinksuploaded')}}
                                                      </div>
                                                    </div>
                                                  </template>

                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="m-separator m-separator--dashed"></div>

                                </div>
                              </div>
                            </div>
                            <!--end: Form Wizard Step 4-->
                          </div>
                          <!--end: Form Body -->

                          <!--begin: Form Actions -->
                          <div class="m-portlet__foot m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions px-3">
                              <div class="row">
                                <div class="col px-0">
                                  <a
                                    href="javascript:"
                                    class="mb-3 btn btn-secondary m-btn m-btn--custom m-btn--icon btn-block-sm"
                                    @click="goToStep(step - 1)"
                                  >
                                    <span>
                                      <i class="la la-arrow-left"></i>
                                      <span>
                                        {{ $t("common.Back") }}
                                      </span>
                                    </span>
                                  </a>

                                  <div class="pull-right btn-block-sm">
                                    <template v-if="step < 4">
                                      <a
                                        href="javascript:"
                                        class="pull-right btn btn-warning m-btn m-btn--custom m-btn--icon btn-block-sm"
                                         @click="goToStep(step + 1)"
                                      >
                                        <span>
                                          {{ $t("common.Next") }}
                                        </span>
                                      </a>
                                    </template>
                                    <template v-else>
                                      <template v-if="mode.type == 'draft'">
                                        <a
                                          href="javascript:"
                                          data-wizard-action="submit"
                                          @click.prevent="publishNow"
                                          class="btn btn-brand m-btn m-btn--custom m-btn--icon btn-block-sm"
                                        >
                                          <span>
                                            <i class="la la-check"></i>
                                            <span>
                                              {{ $t("common.PublishNow") }}
                                            </span>
                                          </span>
                                        </a>
                                        <a
                                          href="javascript:"
                                          data-wizard-action="submit"
                                          data-dismiss="modal"
                                          @click.prevent="publishLater"
                                          class="btn btn-accent m-btn m-btn--custom m-btn--icon btn-block-sm myt-sm-2"
                                        >
                                          <span>
                                            <i class="la la-check"></i>
                                            <span>
                                              {{ $t("common.PublishLater") }}
                                            </span>
                                          </span>
                                        </a>
                                      </template>
                                      <template v-else>
                                        <a
                                          href="javascript:"
                                          data-wizard-action="submit"
                                          @click.prevent="update"
                                          class="btn btn-brand m-btn m-btn--custom m-btn--icon btn-block-sm"
                                        >
                                          <span>
                                            <i class="la la-check"></i>
                                            <span>
                                              {{ $t("common.save") }}
                                            </span>
                                          </span>
                                        </a>
                                      </template>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--end: Form Actions -->
                        </form>
                      </div>

                      <!--end: Form Wizard Form-->
                    </div>
                    <!--end: Form Wizard-->
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  {{ $t("common.Cancel") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- end:: AddModal -->
      </div>
      <template v-if="!canSeeListPropertySection && servicesReady">
        <NoPropertyServices></NoPropertyServices>
      </template>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->
  </div>
</template>

<script>
import AppHeader from "@/components/dashboard/common/Header";
import AppFooter from "@/components/dashboard/common/Footer";
import LeftMenu from "@/components/dashboard/common/menus/LeftMenu";
import NoPropertyServices from "@/components/dashboard/services/Property";

import functions from "@/plugins/functions";

import locationapi from "@/interceptors/locationapi";
import geoserviceapi from "@/interceptors/geoserviceapi";

import Pagination from "@/components/dashboard/common/Pagination";
import vSelect from "vue-select";
import draggable from "vuedraggable";

import { i18n } from "@/plugins/i18n";
import data from "@/plugins/data";

import axios from 'axios'
import { clientapi } from "@/interceptors/clientapi";
import adminapi from "../../../../interceptors/adminapi";

let locationTypeOrder = {
  "country": 1,
  "region": 2,
  "province": 3,
  "coast": 3,
  "municipality": 4,
  "district": 5,
  "neighbourhood": 6,
  "entity": 7,
}
let byLocationType = function (l1, l2) {
  if (locationTypeOrder[l1.type] < locationTypeOrder[l2.type]) {
    return -1;
  }
  if (locationTypeOrder[l1.type] > locationTypeOrder[l2.type]) {
    return 1;
  }
  return 0;
};
let statuses = [
  {
    label: i18n.t("Property.form.All"),
    value: "available",
  },
  {
    label: i18n.t("Property.form.Active"),
    value: "active",
  },
  {
    label: i18n.t("Property.form.Deactivate"),
    value: "deactivated",
  },
];

let featured = [
  {
    label: i18n.t("property.search.featured.all"),
    value: "",
  },
  {
    label: i18n.t("property.search.featured.onlyStandard"),
    value: "Featured",
  },
  {
    label: i18n.t("property.search.featured.onlyPremium"),
    value: "FeaturedPremium",
  },
  {
    label: i18n.t("property.search.featured.allFeatured"),
    value: "Any",
  },
];


const emptyProperty = {
  Town: null,
  Currency: 'EUR',
  ShowAddress: 'no',
  Latitude: null,
  Longitude: null,
  Descriptions: {},
  Photos: [],
  Features: [],
  Medias: []
}

export default {
  components: {
    AppFooter,
    AppHeader,
    LeftMenu,
    NoPropertyServices,
    vSelect,
    draggable,
    Pagination,
  },
  data() {
    return {
      user: {},
      propertyService: {},
      featuredService: {},
      servicesReady: false,
      statuses: statuses,
      featured: featured,
      languageInEdit: 'en',
      orderDirections: [
        { label: i18n.t("common.Asc"), value: "asc" },
        { label: i18n.t("common.Desc"), value: "desc" },
      ],
      orders: [
        { value: "AgentRef", label: i18n.t("Property.table.reference") },
        { value: "Id", label: i18n.t("Property.table.Id") },
        {
          value: "NormalizedPriceInEuro",
          label: i18n.t("Property.table.price"),
        },
        { value: "TownName", label: i18n.t("Property.table.city") },
        { value: "ProvinceName", label: i18n.t("Property.table.province") },
      ],
      radiuses: [2, 5, 10, 15, 20, 25, 30, 40, 50, 75, 100],
      bedrooms: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      bathrooms: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      builds: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
      features: [],
      offerTypes: [
        {
          Id: 2,
          Name: "for-holidays",
          Labels: {
            de: "Ferien",
            en: "Holiday Rental",
            es: "Alquiler Vacacional",
            fr: "Location de vacances",
            it: "Affitti vacanze",
            nl: "Vakantieverhuur",
            no: "Ferieutleie",
            pl: "Kwatery wakacyjne",
            sv: "Semesterbostäder",
          },
        },
        {
          Id: 3,
          Name: "for-sale",
          Labels: {
            de: "Kaufen",
            en: "For Sale",
            es: "Venta",
            fr: "À vendre",
            it: "In Vendita",
            nl: "Te koop",
            no: "Til salgs",
            pl: "Na sprzedaz",
            sv: "Till salu",
          },
        },
        {
          Id: 4,
          Name: "for-rent",
          Labels: {
            de: "Mieten",
            en: "To Rent - Long Term",
            es: "Alquiler",
            fr: "À Louer - Long Terme",
            it: "Da Affittare - Lungo Termine",
            nl: "Te huur - lange termijn",
            no: "Leie - langtids",
            pl: "Na wynajem - Dlugoterminowo",
            sv: "Att hyra - Lång tid",
          },
        },
      ],
      energyRatings: ["A", "B", "C", "D", "E", "F", "G"],
      validPropertyLocationTypes: [ 'municipality', 'entity', 'neighbourhood', 'district' ],
      suggestedLocationsText: '',
      suggestedPropertyLocationsText: '',
      suggestedLocations: [],
      suggestedPropertyLocations: [],
      propertyTypes: [],
      languages: [],
      searchParams: { },
      resultsPerPage: 20,
      step: 1,
      positionEdition: false,
      mediaUrl: '',
      mediaType: 'video',
      mediaTypes: ['video', 'virtualtour', 'floorplan'],
      mode: { type: 'draft', id: null },
      validated: false,
      labelLocation: null,
      copyQuery: null,
      loading: false,
      gMapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#dfe0e4",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ],
      },
      gPinOptions: {
        draggable: true,
        icon: "https://unpkg.com/leaflet@1.3.4/dist/images/marker-icon.png",
      },
      params: {
        OrderDirection: "asc",
        Order: "AgentRef",
        Take: process.env.TAKE_ROWS,
        Skip: 0,
        AgentRef: null,
        MinBathrooms: null,
        MinBedrooms: null,
        Id: null,
        OfferType: "",
        Types: [],
        Status: "available",
        Featured: "",
        MinBuild: null,
        MinPlot: null,
        Price: null,
        MinPrice: null,
        MaxPrice: null,
        Features: [],
        Medias: [],
        Radius: 0,
        Location: null,
        Town: null,
        Province: null,
        Region: null,
        Coast: null,
      },
      property: {
        Town: null,
        Currency: 'EUR',
        Descriptions: {},
        Photos: [],
        Features: []
      },
      drafts: [],
      properties: [],
      OrderBy: {
        type: "Property/AgentRef",
        direction: "asc",
      },
      type: "add", //add || edit || draft (edit item - not published)
      startTab: 1,
      limitFoto: process.env.LIMIT_PHOTOS,
      //List
      //search
      Featured: false,
      FeaturedPremium: false,
      saw: null,
      showPersonalItems: false,
      locationOptions: [],
      selectedLocationSearch: null,
      locType: null,
      locGeo: false,
      pagination: {
        total: 0,
        totalPages: 0,
        currentPage: 1,
        maxVisibleButtons: 3,
      },
      //list
      languagesList: [],
      langUser: this.$i18n.locale,
      ts_url: process.env.TS_URL,
    };
  },
  computed: {
    heading(){
      if (this.searchParams && this.searchParams.Featured){
        return this.featured.filter(f => f.value == this.searchParams.Featured)[0].label
      }

      return i18n.t("property.search.featured.all")
    },
    anyAutoFeatured() {
      return this.properties.filter(p => p.AdInfo && p.AdInfo.UpdatedBy == 'Auto').length
    },
    showAddress: {
      get: function () {
        return this.property.ShowAddress == "yes" ? true : false;
      },
      set: function (val) {
        this.property.ShowAddress = val ? "yes" : "no";
      },
    },
    position: {
      get: function () {
        if (this.property.Latitude && this.property.Longitude) {
          return { lat: this.property.Latitude, lng: this.property.Longitude };
        }
        return null;
      },
      set: function (newValue) {
        this.property.Latitude = newValue.lat;
        this.property.Longitude = newValue.lng;
      },
    },
    isManualService() {
      return this.propertyService.ImportType == "Manual";
    },
    isRent(){
      return this.property.OfferType && this.property.OfferType.Id == 4
    },
    canSeeListPropertySection() {
      let allowedStatuses = ["ACTIVE", "ACTIVE_EXPIRED", "ACTIVE_PENDING"];
      return allowedStatuses.includes(this.propertyService.Status);
    },
    //List
    totalPages() {
      return this.pagination.pages;
    },
    //drafts
    userLang() {
      return this.$i18n.locale;
    },
    //search
    totalFrom() {
      return (
        this.params.Take * this.pagination.currentPage - this.params.Take + 1
      );
    },
    totalTo() {
      if (this.properties.length >= this.params.Take) {
        return this.params.Take * this.pagination.currentPage;
      } else {
        return this.pagination.total;
      }
    },
    OrderByOrder: {
      get() {
        return this.OrderBy.type;
      },
      set(value) {
        this.OrderBy.type = value;
      },
    },
    OrderByDirection: {
      get() {
        return this.OrderBy.direction;
      },
      set(value) {
        this.OrderBy.direction = value;
      },
    },
    totalResults() {
      return this.$utils.formatNumber(this.pagination.total, null, 0);
    },
    hasFeaturedPremium() {
      return this.featuredService.MaxFeaturedPremium > 0;
    },
    hasFeaturedStandard() {
      return this.featuredService.MaxFeaturedStandard > 0;
    },
    hasServices() {
      return (
        this.featuredService.MaxFeaturedPremium > 0 ||
        this.featuredService.MaxFeaturedStandard > 0
      );
    },
    //Add
    makeModalTitle() {
      let title = this.$t("Property.addProperty");
      if (this.type !== "add") {
        title = this.$t("Property.editProperty");
      }
      return title;
    },
    notEditProperty() {
      return this.type !== "edit";
    },
    isHolidayRent() {
      return this.property.OfferType && this.property.OfferType.Id == 2
    },
    countFeatures() {
      if (this.property.Features === null) this.property.Features = [];

      if (this.property.Features.length === 0) return 0;

      let featLeng = this.property.Features.length;

      if (this.property.EnergyRatingConsumption) {
        featLeng++;
      }
      if (this.property.EnergyRatingEmissions) {
        featLeng++;
      }
      if (this.property.YearBuilt) {
        featLeng++;
      }
      if (this.property.Levels) {
        featLeng++;
      }
      if (this.property.FloorNumber) {
        featLeng++;
      }
      if (this.property.Plot) {
        featLeng++;
      }
      if (this.property.Build) {
        featLeng++;
      }
      if (this.property.Bedrooms) {
        featLeng++;
      }
      if (this.property.Bathrooms) {
        featLeng++;
      }
      if (this.property.Toilets) {
        featLeng++;
      }

      return featLeng;
    },
    hasFeatures() {
      return (
        this.property.EnergyRatingConsumption ||
        this.property.EnergyRatingEmissions ||
        this.property.YearBuilt ||
        this.property.Levels ||
        this.property.FloorNumber ||
        this.property.Plot ||
        this.property.Build ||
        this.property.Bedrooms ||
        this.property.Bathrooms ||
        this.property.Toilets ||
        this.property.Features !== null
      );
    },
    locations() {
      return (
        this.property.DistanceToAirport ||
        this.property.DistanceToBeach ||
        this.property.DistanceToCountry ||
        this.property.DistanceToGolf ||
        this.property.DistanceToMarina ||
        this.property.DistanceToTown
      );
    },
  },
  async mounted(){
    this.ready()
  },
  beforeRouteLeave (to, from, next) {
    this.closeModalAdd()
    next()
  },
  beforeDestroy(){
    this.closeModalAdd()
  },
  methods: {
    labelForFeature(feature) {
      let found = this.features.filter( f => f.value == feature);
      if (found.length == 0) {
        return feature;
      }
      return found[0].Labels[this.userLang];
    },
    setAltImageFromCdnUrl(event){
      if (event.target.dataset.setAltImageHandled) {
        return
      }
      event.target.dataset.setAltImageHandled = 'true'

      if (!event.target.dataset.cdnurl) {
        return
      }
      if (event.target.src != event.target.dataset.cdnurl) {
        event.target.src = event.target.dataset.cdnurl
      }
    },
    setAltImageFromOrgUrl(event){
      if (event.target.dataset.setAltImageHandled) {
        return
      }
      event.target.dataset.setAltImageHandled = 'true'

      if (!event.target.dataset.orgurl) {
        return
      }
      if (event.target.src != event.target.dataset.orgurl) {
        event.target.src = event.target.dataset.orgurl
      }
    },
    async ready() {
      this.user = functions.getUser();
      this.propertyService = await functions.getPropertyService();
      this.featuredService = await functions.getFeaturedService();
      this.servicesReady = true;

      let byName = function (c1, c2) {
        var name1 = c1.name.toUpperCase();
        var name2 = c2.name.toUpperCase();
        if (name1 < name2) {
          return -1;
        }
        if (name1 > name2) {
          return 1;
        }
        return 0;
      };
      let lang = this.$i18n.locale ? this.$i18n.locale : "en";
      let listOfLanguages = data
        .languages()
        .map((language) => {
          return { code: language.code, name: language.Labels[lang] };
        })
        .sort(byName);
      this.languages = listOfLanguages;

      let propertyTypes = data.propertyTypes()

      let byLabelLang = function(pt1, pt2){
        let name1 = pt1.Labels[lang].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        let name2 = pt2.Labels[lang].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        if (name1 < name2) {
          return -1;
        }
        if (name1 > name2) {
          return 1;
        }
        return 0;
      }

      propertyTypes.sort(byLabelLang)
      this.propertyTypes = propertyTypes
      let featuresFromApi = await adminapi.get('/feature')
      let features = featuresFromApi.data.map(f => { return { value: f.key, Labels: f.labels } } );
      features.sort(byLabelLang)
      this.features = features

      if (!this.canSeeListPropertySection) {
        return;
      }
      if (this.$route.name == 'FeaturedProperties'){
        this.params.Featured = 'Any'
      }

      this.initialize();
      this.getDrafts();
    },
    openLink(mediaUrl){
      return window.open(mediaUrl, "_blank")
    },
    getFirstPhoto(property){

      let photos = property.Photos

      if(!photos || photos.length == 0){
        return null
      }

      let photo = photos[0]

      for (let p of photos) {
        if (p.Number < photo.Number) {
          photo = p
        }
      }
      return photo
    },
    formatCdnPath(url) {
      if (!url) return ''

      let urlChunks = url.split("/");

      if (urlChunks.length < 3) {
        return '';
      }

      urlChunks.splice(urlChunks.length - 1, 0, "s400x300");

      return urlChunks.join("/");
    },
    async suggestLocations(search, loading) {
      this.suggestedLocationsText = search;

      if (search.length <= 2) {
        this.suggestedLocations = [];
        return;
      }

      loading(true);
      let result = await geoserviceapi.get("/locationwithtext", {
        params: { query: search, lang: this.$i18n.locale, limit: 10 },
      });

      if (result.status == 200) {
        var locations = result.data;
        locations.sort(byLocationType);
        this.suggestedLocations = locations;
      }
      loading(false);
    },
    formatSuggestedLocation( option, match ) {
       return `${this.highlightPartOfText( option.text[this.userLang], match)}<br><span><span style="font-size: 11px">${this.$t('Location.location-description-' + option.typeDescriptionKey)}</span>`
    },
    highlightPartOfText( text, part ) {
      const position = text.toLowerCase().indexOf(part.toLowerCase())

      if (position < 0) {
        return text;
      }

      const before = text.substring(0, position)
      const between = text.substring(position, position + part.length)
      const after = text.substring(position + part.length)

      const result = [before, '<strong>', between, '</strong>', after].join('')
      return result
    },
    async suggestPropertyLocations(search, loading) {
      this.suggestedPropertyLocationsText = search;

      if (search.length <= 2) {
        this.suggestedPropertyLocations = [];
        return;
      }
      loading(true);
      let result = await geoserviceapi.get("/locationwithtext", {
        params: { query: search, lang: this.$i18n.locale, limit: 10 },
      });
      if (result.status == 200) {
        let locations = result.data.filter( l => this.validPropertyLocationTypes.includes(l.type) )
        locations.sort(byLocationType);
        this.suggestedPropertyLocations = locations
      }
      loading(false);
    },
    async initialize() {
      WizardForm.init();
      $("#modalPropertyAdd").modal("hide");

      //add
      await this.runSearch()
    },
    async addProperty() {

      if (this.propertyService.ImportType == "XML") {
        swal({
          title: this.$t("Property.xmlMessage.title"),
          text: this.$t("Property.xmlMessage.text"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
        return false;
      }

      this.propertiesBlock();

      this.property = JSON.parse(JSON.stringify(emptyProperty))

      //get active properties
      let countResponse = await clientapi.get("/property/count", {
        params: { Status: "active" },
      });

      let activeProperties = countResponse.data.count;

      this.propertiesUnblock();

      if (activeProperties + 1 > this.propertyService.PropertyLimit) {
        swal({
          title: this.$t("Property.maxLimitReached.title"),
          text: this.$tc("Property.maxLimitReached.text", {
            limit: this.propertyService.PropertyLimit,
          }),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
        });
        return false;
      }

      this.mode = { type: 'draft', id: null }
      WizardForm.r.goFirst();
      $("#modalPropertyAdd").modal("show");
    },
    onPageChange(page) {
      this.pagination.currentPage = page;
      this.params.Skip = (page - 1) * this.params.Take;
      this.runSearch();
    },
    openPI() {
      $("#personalItemList").collapse();
    },
    async getDrafts() {
      let response = await clientapi.get('/items', { params: { type: 'new-property' } })

      if (response.status != 200){
        return
      }

      this.drafts = (response.data || []).filter(r => r.Content != null)
    },
    async deletePersonalItem(id) {
      let confirm = await swal({
        title: this.$t("common.areyousure"),
        text: this.$t("error.YouAreAboutToRemoveAtemporaryProperty"),
        showCancelButton: !0,
        confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
        confirmButtonText: this.$t("common.yesRemoveIt"),
        cancelButtonText: this.$t("common.Cancel"),
        type: "warning",
        onBeforeOpen: () => {
          functions.onBeforeOpenSwal();
        },
      })

      if (!confirm.value){
        return
      }

      let response = await clientapi.delete(`/items/${id}`)

      if (response.status != 200){
        swal({
          title: this.$t("error.SomethingWentWrong"),
          text: this.$t("error.YourPropertyWasNotDeleted"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
        return
      }

      this.getDrafts()
    },
    formatMoney(price) {
      return this.$utils.formatNumber(price, null, 0);
    },
    freshSearch(){
      this.pagination.currentPage = 1;
      this.params.Skip = 0;
      this.runSearch();
    },
    setUpHideShowFilters() {
      let vueThis = this;

      let form = document.getElementById("PropertySearchFrm");
      let $form = $(form);

      $form.on("hide.bs.collapse", function () {
        document.getElementById("moreFiltersSpan").innerHTML = vueThis.$t(
          "Property.Analytics.MoreFilters"
        );
      });
      $form.on("show.bs.collapse", function () {
        document.getElementById("moreFiltersSpan").innerHTML = vueThis.$t(
          "Property.Analytics.Hidefilters"
        );
      });
    },
    clearForm() {
      this.params = {
        OrderDirection: "asc",
        Order: "AgentRef",
        Take: process.env.TAKE_ROWS,
        Skip: 0,
        AgentRef: null,
        MinBathrooms: null,
        MinBedrooms: null,
        Id: null,
        OfferType: "",
        Types: [],
        Status: "available",
        Featured: "",
        MinBuild: null,
        MinPlot: null,
        Price: null,
        MinPrice: null,
        MaxPrice: null,
        Features: [],
        Medias: [],
        Radius: 0,
        Location: null,
        Town: null,
        Province: null,
        Region: null,
        Coast: null,
      }
    },
    async runSearch() {
      this.loading = true;
      this.propertiesBlock();
      await this.search();
      this.loading = false;
      this.propertiesUnblock();
    },
    async search() {
      this.searchParams = JSON.parse(JSON.stringify(this.params));

      let urlParams = new URLSearchParams();

      urlParams.set(
        "Skip",
        (this.pagination.currentPage - 1) * this.resultsPerPage
      );
      urlParams.set("Take", this.resultsPerPage);

      switch (this.searchParams.Status) {
        case "active":
          urlParams.set("Status", "active");
          break;
        case "deactivated":
          urlParams.set("Status", "deactivated");
          break;
        default:
          urlParams.set("Status", "available");
      }

      switch (this.searchParams.Order) {
        case "Id":
          urlParams.set(
            "Order",
            `Property/Id ${this.searchParams.OrderDirection}`
          );
          break;
        case "NormalizedPriceInEuro":
          urlParams.set(
            "Order",
            `Property/NormalizedPriceInEuro ${this.searchParams.OrderDirection}`
          );
          break;
        case "TownName":
          urlParams.set(
            "Order",
            `Town/Name ${this.searchParams.OrderDirection}`
          );
          break;
        case "ProvinceName":
          urlParams.set(
            "Order",
            `Province/Name ${this.searchParams.OrderDirection}`
          );
          break;
        default:
          urlParams.set(
            "Order",
            `Property/AgentRef ${this.searchParams.OrderDirection}`
          );
          break;
      }

      if (this.searchParams.Featured) {
        urlParams.set("Featured", this.searchParams.Featured);
      }

      if (this.searchParams.Id) {
        urlParams.set("Id", this.searchParams.Id);
      }

      if (this.searchParams.AgentRef) {
        urlParams.set("Ref", '%' + this.searchParams.AgentRef + '%');
      }

      if (this.searchParams.Location && this.searchParams.Location.id) {
        urlParams.set("Location", this.searchParams.Location.id);

        if (this.searchParams.Radius) {
          urlParams.set("Nearby.Radius", this.searchParams.Radius * 1000);
          urlParams.set("Nearby.Latitude", this.searchParams.Location.center.lat);
          urlParams.set("Nearby.Longitude", this.searchParams.Location.center.lon);
        }
      }

      for (let type of this.searchParams.Types) {
        urlParams.append("Type", type.Id);
      }

      if (this.searchParams.MinPrice) {
        urlParams.set("MinPrice", this.searchParams.MinPrice);
      }

      if (this.searchParams.MaxPrice) {
        urlParams.set("MaxPrice", this.searchParams.MaxPrice);
      }

      if (this.searchParams.Bedrooms) {
        urlParams.set("MinBedrooms", this.searchParams.Bedrooms);
      }

      if (this.searchParams.Bathrooms) {
        urlParams.set("MinBathrooms", this.searchParams.Bathrooms);
      }

      for (let feature of this.searchParams.Features) {
        urlParams.append("Features", feature.value);
      }

      if (this.searchParams.Build) {
        urlParams.set("MinBuild", this.searchParams.Build);
      }

      if (this.searchParams.Plot) {
        urlParams.set("MinPlot", this.searchParams.Plot);
      }

      if (this.searchParams.OfferType) {
        urlParams.set("Offer", this.searchParams.OfferType);
      }

      let countUrlParams = new URLSearchParams(urlParams.toString());
      countUrlParams.delete("Take");
      countUrlParams.delete("Skip");

      let [propertiesResponse, countResponse] = await Promise.all([
        clientapi.get("/property", { params: urlParams }),
        clientapi.get("/property/count", { params: countUrlParams }),
      ]);

      if (propertiesResponse.status != 200 || countResponse.status != 200) {
        swal({
          html: this.$t("error.ServerError.text"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
        return;
      }

      this.properties = propertiesResponse.data;
      this.pagination.total = countResponse.data.count;
      this.pagination.totalPages = Math.ceil(
        countResponse.data.count / this.resultsPerPage
      );
    },
    propertiesBlock() {
      mApp.block("body", {
        centerX: true,
        centerY: true,
        message: this.$t("common.LoadingDataPleaseWait"),
      });
    },
    propertiesUnblock() {
      mApp.unblock("body");
    },
    //list
    showPrice(item) {
      return this.$utils.showPrice(item);
    },
    showMediaIcon(type) {
      if (type === 'video'){
        return '<i class="la la-youtube-play "></i>'
      }
      if (type === 'floorplan'){
        return '<i class="la la-map"></i>'
      }
      if (type === 'virtualtour'){
        return '<i class="la la-street-view "></i>'
      }
      return ''
    },
    async deactivateFeatured(propertyId) {

      // if search was made for all properties then there is no need to show confirmation
      if (this.searchParams.Featured !== "") {
        let confirmed = await swal({
            title: this.$t('property.removeFeaturedConfirmationText'),
            showCancelButton: true,
            confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
            confirmButtonText: this.$t('common.Yes'),
            cancelButtonText: this.$t('common.Cancel'),
            type: "warning",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });

        if (!confirmed.value) {
          return
        }
      }

      let response = await clientapi.delete('/featured/' + propertyId)

      if (response.status != 200){
        swal({
          title: this.$t("error.AnErrorOccurred"),
          text: this.$t("error.AnErrorOccurred"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
        return
      }

      this.runSearch()
    },
    async activateFeatured(propertyId, type) {
      let response = await clientapi.post('/featured', { type: type, id: propertyId})

      if (response.status != 200){
        if (response.data && response.data.code == "ErrFeaturedPremiumExceeded") {
          swal({
            title: this.$t("error.server.ErrFeaturedPremiumExceeded", { limit: this.featuredService.MaxFeaturedPremium}),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            footer: `<a href="/advertise"><strong>${this.$t('property.GetMoreFeatured')}</strong></a>`,
            onBeforeOpen: () => {
              functions.onBeforeOpenSwal();
            },
          });
          return
        }

        if (response.data && response.data.code == "ErrFeaturedExceeded") {
          swal({
            title: this.$t("error.server.ErrFeaturedExceeded", {limit: this.featuredService.MaxFeaturedStandard}),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            footer: `<a href="/advertise"><strong>${this.$t('property.GetMoreFeatured')}</strong></a>`,
            onBeforeOpen: () => {
              functions.onBeforeOpenSwal();
            },
          });
          return
        }

        swal({
          title: this.$t("error.AnErrorOccurred"),
          text: this.$t("error.AnErrorOccurred"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
        return
      }

      this.runSearch()
    },
    async removeProperty(propertyId) {

      if (this.propertyService.ImportType == 'XML'){
        let confirm = await swal({
          title: this.$t("Directory.DATA-OVERWRITE-WARNING"),
          text: this.$t("error.YouAreImportingYourPropertiesByDataFeed"),
          type: "info",
          showCancelButton: !0,
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          confirmButtonText: this.$t("common.okGotIt"),
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        })

        if (!confirm.value){
          return
        }
      }

      let confirm = await swal({
        title: this.$t("common.areyousure"),
        text: this.$t("property.deletionConfirmationText"),
        showCancelButton: !0,
        confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
        confirmButtonText: this.$t("Directory.YesDoIt"),
        cancelButtonText: this.$t("common.Cancel"),
        type: "warning",
        onBeforeOpen: () => {
          functions.onBeforeOpenSwal();
        },
      })

      if (!confirm.value){
        return
      }

      let response = await clientapi.delete('/property/' + propertyId)

      if (response.status == 200){
        swal({
          title: this.$t("PersonalItems.PropertyDeleted"),
          text: this.$t("Property.PropertyWasDeleted"),
          type: "success",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });

        await this.search()
      } else {
        swal({
          title: this.$t("error.AnErrorOccurred"),
          text: this.$t("error.AnErrorOccurred"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
      }
    },
    async activate(propertyId) {
      if (this.propertyService.ImportType == 'XML' && !this.propertyService.ManualSelection){
        let confirm = await swal({
          title: this.$t("Directory.DATA-OVERWRITE-WARNING"),
          text: this.$t("Property.xmlMessageActivate.text"),
          showCancelButton: !0,
          confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
          confirmButtonText: this.$t("Directory.YesDoIt"),
          cancelButtonText: this.$t("common.Cancel"),
          type: "warning",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        })

        if (!confirm.value){
          return
        }
      }

      let confirm = await swal({
        title: this.$t("common.areyousure"),
        text: this.$t("property.activationConfirmationText"),
        showCancelButton: !0,
        confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
        confirmButtonText: this.$t("Directory.YesDoIt"),
        cancelButtonText: this.$t("common.Cancel"),
        type: "warning",
        onBeforeOpen: () => {
          functions.onBeforeOpenSwal();
        },
      })

      if (!confirm.value){
        return
      }

      let result = await clientapi.post(`/property/${propertyId}/activate`)

      if (result.status == 400 && result.data.code == "ErrPropertyServiceLimit"){
        swal({
          title: this.$t("Property.maxLimitReached.title"),
          text: this.$tc("Property.maxLimitReached.text", {
            limit: this.propertyService.PropertyLimit,
          }),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      }
      else if (result.status != 200){
        swal({
          title: this.$t('error.AnErrorOccurred'),
          text: this.$t('error.AnErrorOccurred'),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      } else {
        swal({
          title: this.$t("property.PropertyActivated"),
          text: this.$t("property.PropertyActivatedLong"),
          type: "success",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
      }

      await this.search()
    },
    async deactivate(propertyId) {
      if ( this.propertyService.ImportType == 'XML' && !this.propertyService.ManualSelection ){
        let confirm = await swal({
          title: this.$t("Directory.DATA-OVERWRITE-WARNING"),
          text: this.$t("Property.xmlMessageDeActivate.text"),
          showCancelButton: !0,
          confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
          confirmButtonText: this.$t("Directory.YesDoIt"),
          cancelButtonText: this.$t("common.Cancel"),
          type: "warning",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        })

        if (!confirm.value){
          return
        }
      }

      let confirm = await swal({
        title: this.$t("common.areyousure"),
        text: this.$t("property.deactivationConfirmationText"),
        showCancelButton: !0,
        confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
        confirmButtonText: this.$t("Directory.YesDoIt"),
        cancelButtonText: this.$t("common.Cancel"),
        type: "warning",
        onBeforeOpen: () => {
          functions.onBeforeOpenSwal();
        },
      })

      if (!confirm.value){
        return
      }

      let result = await clientapi.post(`/property/${propertyId}/deactivate`)

      if (result.status != 200){
        swal({
          title: this.$t('error.AnErrorOccurred'),
          text: this.$t('error.AnErrorOccurred'),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      } else {
        swal({
          title: this.$t("property.PropertyDeactivated"),
          text: this.$t("property.PropertyDeactivatedLong"),
          type: "success",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
      }

      await this.search()
    },
    async editProperty(property) {

      //first check if this is an xml import to display warning
      if (this.propertyService.ImportType == 'XML'){
        let confirm = await swal({
          title: this.$t("Directory.DATA-OVERWRITE-WARNING"),
          text: this.$t("Property.xmlFeedWarningBeforeEdition"),
          type: "info",
          showCancelButton: !0,
          confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
          confirmButtonText: this.$t("common.okGotIt") + " !!",
          cancelButtonText: this.$t("common.Cancel"),
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        })

        if (!confirm.value) {
          return
        }
      }

      WizardForm.r.goFirst();

      this.property = JSON.parse(JSON.stringify(property));

      //replace br for descriptions
      for (let lang in this.property.Descriptions){
        this.property.Descriptions[lang] = this.property.Descriptions[lang].replace(/<br\s?\/?>/g, '\n').replace(/\n\s*\n\s*\n/g, '\n\n')
      }

      if (!this.property.Photos) {
        this.property.Photos = []
      }

      //sort order of photos by number (in asc order)
      if (this.property.Photos) {
        this.property.Photos = this.property.Photos.sort((i, j) => {
          if (i.Number < j.Number){
            return -1
          }

          return 1
        })
      }

      this.mode = { type: 'edit', id: property.Id }

      $("#modalPropertyAdd").modal("show");
    },
    async update(){
      let validStatus = this.validate()

      if (!validStatus.valid){
        this.goToStep(validStatus.step ? validStatus.step : 1);
        swal({
          title: this.$t(validStatus.error),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      }

      mApp.block("body", {
        message: this.$t("common.LoadingDataPleaseWait"),
      });

      let result = await clientapi.put('/property/' + this.mode.id, this.getPayload())

      mApp.unblock("body")

      //validation issue  from the server
      if (result.status == 400 && result.data && result.data.code == 'ErrTooManyPhotos'){
        this.goToStep(3)
        swal({
          text: this.$t('error.server.ErrTooManyPhotos'),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      }

      if (result.status == 400 && result.data && result.data.code == 'ErrTooManyVideos'){
          this.goToStep(3)

          swal({
            title: this.$t('error.TooManyVideosSelected'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status == 400 && result.data && result.data.code == 'ErrTooManyVirtualTours'){
          this.goToStep(3)

          swal({
            title: this.$t('error.TooManyVirtualToursSelected'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status == 400 && result.data && result.data.code == 'ErrInvalidPrice'){
          this.goToStep(1)

          swal({
            title: this.$t('error.server.ErrInvalidPrice'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status != 200) {
        swal({
          title: this.$t('error.AnErrorOccurred'),
          text: this.$t('error.AnErrorOccurred'),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      }

      swal({
        title: this.$t('Property.PropertyEdited'),
        text: this.$t('Property.PropertyEditedCorrect'),
        type: "success",
        confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
        onBeforeOpen: () => { functions.onBeforeOpenSwal() }
      })

      this.goToStep(1)
      $("#modalPropertyAdd").modal("hide");
      this.search()
    },
    getPayload(){
      let payload = {
        Online: true,
        Price: this.property.Price,
        Currency: this.property.Currency,
        Ref: this.property.AgentRef,
        Location: this.property.Location.id,
        Offer: this.property.OfferType.Id,
        Type: this.property.Type.Id,
        Build: this.property.Build || null,
        Plot: this.property.Plot || null,
        Bathrooms: this.property.Bathrooms || null,
        Bedrooms: this.property.Bedrooms || null,
        Toilets: this.property.Toilets || null,
        Distance: {
          Town: this.property.DistanceToTown || null,
          Airport: this.property.DistanceToAirport || null,
          Marina: this.property.DistanceToMarina || null,
          Beach: this.property.DistanceToBeach || null,
          Mountains: this.property.DistanceToMountains || null,
          Golf: this.property.DistanceToGolf || null,
          Country: this.property.DistanceToCountry || null
        },
        HighSeasonPrice: this.property.HighSeasonPrice || null,
        Latitude: this.property.Latitude || null,
        Longitude: this.property.Longitude || null,
        GeoInfo: this.property.GeoInfo,
        Address: this.property.Address,
        ShowAddress: this.property.ShowAddress,
        EnergyRatingConsumption: this.property.EnergyRatingConsumption,
        EnergyRatingEmissions: this.property.EnergyRatingEmissions,
        YearBuilt: this.property.YearBuilt || null,
        FloorNumber: this.property.FloorNumber,
        Levels: this.property.Levels || null,
        CadastralReference: this.property.CadastralReference,
        Photos: this.property.Photos,
        Medias: this.property.Medias,
        Features: this.property.Features,
        Descriptions: this.property.Descriptions
      }

      //fix photo ordering
      for(let i = 0; i < payload.Photos.length; i++){
        payload.Photos[i].Number = i+1
      }

      return payload
    },
    validate() {

      this.validated = true

      if (!this.property.AgentRef){
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.AgentRef.length > 100) {
        return {valid: false, error: "error.FieldTooLong"}
      }

      if (!this.property.Type){
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (!this.property.OfferType){
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (!this.property.Price){
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Price.toString().includes(".")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Price.toString().includes(",")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      // check for maximum allowed value
      if (this.property.Price.toString().length > 9) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Bedrooms && this.property.Bedrooms.toString().includes(".")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Bedrooms && this.property.Bedrooms.toString().includes(",")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Bathrooms && this.property.Bathrooms.toString().includes(".")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Bathrooms && this.property.Bathrooms.toString().includes(",")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Toilets && this.property.Toilets.toString().includes(".")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Toilets && this.property.Toilets.toString().includes(",")) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (!this.property.Location){
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (!this.property.Currency) {
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Latitude && this.property.Longitude && !this.property.GeoInfo){
        return {valid: false, error: "error.PleaseFillUpAllMissingFields"}
      }

      if (this.property.Longitude && (this.property.Longitude < -18.167 || this.property.Longitude > 6.033)) {
        return {valid: false, error: "error.InvalidLatitudeAndLongitude"}
      }

      if (this.property.Latitude &&  (this.property.Latitude < 27.633 || this.property.Latitude > 44)) {
        return {valid: false, error: "error.InvalidLatitudeAndLongitude"}
      }

      if (this.property.Medias) {
        var videos = this.property.Medias.filter(m => m.type == 'video')
        var virtualTours = this.property.Medias.filter(m => m.type == 'virtualtour')

        if (videos.length > 1) {
          return { valid: false, error: "error.TooManyVideosSelected", step: 3}
        }

        if (virtualTours.length > 1) {
          return { valid: false, error: "error.TooManyVirtualToursSelected", step: 3}
        }
      }

      if (this.property.FloorNumber && this.property.FloorNumber.length > 20) {
        return { valid:false, error: "error.InvalidField" }
      }

      return {valid: true}
    },
    async publishNow(){
      let validStatus = this.validate()

      if (!validStatus.valid){
        this.goToStep(validStatus.step ? validStatus.step : 1);
        swal({
          title: this.$t(validStatus.error),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      }

      mApp.block("body", {
        message: this.$t("common.LoadingDataPleaseWait"),
      });

      let result = await clientapi.post('/property', this.getPayload())

      mApp.unblock("body");

      if (result.status == 400 && result.data.code == 'ErrDuplicateRef'){
          this.goToStep(1)

          swal({
            title: null,
            text: this.$t('error.ErrDuplicateRef'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return

      }

      if (result.status == 400 && result.data.code == 'ErrPropertyServiceLimit'){
          this.goToStep(1)

          swal({
            title: this.$t("Property.maxLimitReached.title"),
            text: this.$tc("Property.maxLimitReached.text", {
              limit: this.propertyService.PropertyLimit,
            }),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return

      }

      if (result.status == 400 && result.data && result.data.code == 'ErrInvalidMedia'){
          this.goToStep(3)

          swal({
            title: null,
            text: this.$t('error.ErrInvalidMedia'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status == 400 && result.data && result.data.code == 'ErrTooManyPhotos'){
          this.goToStep(3)

          swal({
            title: null,
            text: this.$t('error.server.ErrTooManyPhotos'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status == 400 && result.data && result.data.code == 'ErrTooManyVideos'){
          this.goToStep(3)

          swal({
            title: this.$t('error.TooManyVideosSelected'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status == 400 && result.data && result.data.code == 'ErrTooManyVirtualTours'){
          this.goToStep(3)

          swal({
            title: this.$t('error.TooManyVirtualToursSelected'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status == 400 && result.data && result.data.code == 'ErrInvalidPrice'){
          this.goToStep(1)

          swal({
            title: this.$t('error.server.ErrInvalidPrice'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return
      }

      if (result.status != 200) {
        swal({
          title: this.$t('error.AnErrorOccurred'),
          text: this.$t('error.AnErrorOccurred'),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })
        return
      }

      swal({
        title: this.$t('Property.PropertyEdited'),
        text: this.$t('Property.PropertyEditedCorrect'),
        type: "success",
        confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
        onBeforeOpen: () => { functions.onBeforeOpenSwal() }
      })

      this.goToStep(1)
      $("#modalPropertyAdd").modal("hide");
      if (this.mode.type == 'draft' && this.mode.id){
        await clientapi.delete('/items/' + this.mode.id)
      }

      this.getDrafts()

    },
    editPersonalItem(draft) {
      WizardForm.r.goFirst();
      this.property = JSON.parse(JSON.stringify(draft.Content));
      this.mode = { type: 'draft', id: draft.Id }

      $("#modalPropertyAdd").modal("show");
    },
    async publishLater(){
      if (this.mode.id){
        let response = await clientapi.put(`/items/${this.mode.id}`, { Type: 'new-property', Content: this.property  })
        if (response.status != 200){
          swal({
            title: "",
            text: vueThis.$t("error.ThereAreSomeErrorsInYourSubmission"),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => {
              functions.onBeforeOpenSwal();
            },
          });
        }
      } else {
        let response = await clientapi.post('/items', { Type: 'new-property', Content: this.property  })
        if (response.status != 200){
          swal({
            title: "",
            text: vueThis.$t("error.ThereAreSomeErrorsInYourSubmission"),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => {
              functions.onBeforeOpenSwal();
            },
          });
        }
      }

      this.goToStep(1)
      $("#modalPropertyAdd").modal("hide");
      this.getDrafts()
    },
    closeModalAdd() {
      $("#modalPropertyAdd").modal("hide");
    },
    clearCoord() {
      this.property.Latitude = null
      this.property.Longitude = null
    },
    getTownDisplayName(town){
      if (!town.Labels || !town.Labels.province) {
        return ''
      }
      return `${town.Labels.Default}, ${town.Labels.province.Default}`
    },
    async getLatLngFromAddress(event) {
      mApp.block(event.target);

      //this will make sure google plugin is loaded
      await this.$gmapApiPromiseLazy();
      let geocoder = new google.maps.Geocoder();

      let address =
        this.property.Address +
        ", " +
        this.property.Location.text['en'] +
        ", Spain";

      await geocoder.geocode({ address: address }, (results, status) => {
        mApp.unblock(event.target);
        if (status != "OK" || results.length == 0) {
          swal({
            title: this.$t("Dashboard.noresults"),
            text: this.$t(
              "Directory.ThereWhereNoResultsFoundWithTheProvidedFullAddress"
            ),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => {
              functions.onBeforeOpenSwal();
            },
          });
        }

        let result = results[0];

        this.property.Latitude = result.geometry.location.lat();
        this.property.Longitude = result.geometry.location.lng();
      });
    },

    async positionMoved(marker) {
      let confirm = await swal({
        title: this.$t("common.areyousure"),
        text: this.$t(
          "Property.YouAreAboutToChangeLatitudeAndLongitudeOfTheProperty"
        ),
        showCancelButton: !0,
        confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
        confirmButtonText: this.$t("Directory.YesDoIt"),
        cancelButtonText: this.$t("common.Cancel"),
        type: "warning",
        onBeforeOpen: () => {
          functions.onBeforeOpenSwal();
        },
      });

      if (!confirm.value) {
        return;
      }

      this.property.Latitude = marker.latLng.lat();
      this.property.Longitude = marker.latLng.lng();
    },
    getCurrentLocation(event) {
      if (!navigator.geolocation) {
        return;
      }

      mApp.block(event.target);

      let component = this;

      let success = function (position) {
        component.property.Latitude = position.coords.latitude;
        component.property.Longitude = position.coords.longitude;
      };

      let error = function () {
        swal({
          title: component.$t("Directory.MissingCoordenates"),
          text: component.$t("Directory.WeCouldntGeolcateYou"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
      };

      navigator.geolocation.getCurrentPosition(success, error);

      mApp.unblock(event.target);
    },
    toggleAddEdit() {
      this.positionEdition = !this.positionEdition;
    },
    //Step3
    addMedia() {

      if (!this.mediaUrl || !this.mediaType) {
        swal({
          title: this.$t("error.MissingFields"),
          text: this.$t("error.PleaseFillUpAllMissingFields"),
          type: "error",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => {
            functions.onBeforeOpenSwal();
          },
        });
        return
      }

      this.property.Medias.push({url: this.mediaUrl, type: this.mediaType})

      this.mediaUrl = ''

    },
    removeMedia(index) {
      this.property.Medias.splice(index, 1)
    },
    async deleteImage(index) {

      let confirm = await swal({
        title: this.$t("common.areyousure"),
        text: this.$t("common.aboutDeleteImg"),
        showCancelButton: !0,
        confirmButtonClass: "btn btn-brand m-btn m-btn--custom",
        confirmButtonText: this.$t("common.yesRemoveIt"),
        cancelButtonText: this.$t("common.Cancel"),
        type: "warning",
        onBeforeOpen: () => {
          functions.onBeforeOpenSwal();
        },
      })

      if (!confirm.value){
        return
      }

      this.property.Photos.splice(index, 1)
    },
    getFilename(url) {
      return this.$utils.getFilename(url);
    },
    updateImageList() {
      this.property.Photos.forEach((photo, index) => {
        photo.Number = index + 1;
      });
    },
    async onFileChange(e) {
      //first validate file
      for (let img of e.target.files){
        if (!['image/png','image/jpeg'].includes(img.type)){
          swal({
            title: this.$t('common.FormatNotAllowed'),
            text: this.$t('common.FormatNotAllowedImg'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
          return;
        }

        if (img.size > 30720000) {
          swal({
            title: this.$t('common.sizeToBig'),
            text: this.$t('common.sizeToBigFile'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
          return;
        }
      }

      //use natural sort, e.g. photo 3.jpg vs photo 12.jpg
      var filesToUpload = [...e.target.files].sort( (a, b) => a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}) )

      mApp.block("body", {
        centerX: true,
        centerY: true,
        message: "Photos being uploaded <span id='uploadProgress'>0</span> of " + filesToUpload.length,
      })


      var photos = [];

      for (let i = 0; i < filesToUpload.length; i++) {
        let img = filesToUpload[i]

        //getting pre-signed url
        let body = {
          "ContentType": img.type,
          "Size": img.size,
          "Name": img.name
        }

        let presignedRequest = await clientapi.post(`/upload/image`, body)
        if (presignedRequest.status != 200){
          mApp.unblock("body");
          await swal({
                title: this.$t('error.ServerError400Image.title'),
                text: this.$t('error.ServerError400Image.text'),
                type: "error",
                confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
                onBeforeOpen: () => { functions.onBeforeOpenSwal() }
              });
          return
        }

        var uploadFile = await axios.put(presignedRequest.data.FileUploadURL, img, {headers: {"content-type": img.type, "x-amz-acl": "public-read" }})
        if (uploadFile.status != 200){
          mApp.unblock("body");
          await swal({
                title: this.$t('error.ServerError400Image.title'),
                text: this.$t('error.ServerError400Image.text'),
                type: "error",
                confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
                onBeforeOpen: () => { functions.onBeforeOpenSwal() }
              });
          return
        }
        //show progress
        document.getElementById('uploadProgress').innerHTML = i+1

        photos.push({ Url: presignedRequest.data.FileUploadURL.split('?')[0] })

      }

      mApp.unblock("body");

      if (!this.property.Photos) this.property.Photos = []

      photos.forEach((photo) => {
          this.property.Photos.push(photo)
      })

    },
    movePhotoUp(index) {
      let elements = [this.property.Photos[index], this.property.Photos[index - 1]];
      this.property.Photos.splice(index - 1, 2, elements[0], elements[1] );
    },
    movePhotoDown(index) {
      let elements = [this.property.Photos[index], this.property.Photos[index + 1]];
      this.property.Photos.splice(index, 2, elements[1], elements[0] );
    },
    isHollidayRent() {
      return this.property.OfferType && this.property.OfferType.Id == 2;
    },
    locationsTexts(type) {
      if (type === "exact") {
        return this.$t("Property.form.Coordinates.radiobtn.exactLocation");
      }
      if (type === "street") {
        return this.$t("Property.form.Coordinates.radiobtn.streetLocation");
      }
      if (type === "approx") {
        return this.$t("Property.form.Coordinates.radiobtn.approxLocation");
      }
      if ( type == "town" ) {
        return this.$t("Property.form.Coordinates.radiobtn.townLocation");
      }
    },
    goToStep(step) {
      this.step = parseInt(step);
      WizardForm.r.currentStep = step - 1;
      WizardForm.r.goTo(step);
      $("#modalPropertyAdd").scrollTop(0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/property/List/Properties.vue